export default {
    generalErrorMessage: {
        fieldIsRequired: "field is required",
        field_required: "This field is required",
        something_went_wrong: "Something went wrong",
    },
    authErrorMessage: {
        emailError: "The email field must be a valid email",
        passwordValid: "The password field must be at least 8 characters",
        validPassRegex:
            "passwords must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character",
        confirmPasswordValid:
            "The confirm password confirmation does not match",
        validCharactersfirst:
            "The first name field may only contain alphabetic characters as well as spaces",
        validCharacterslast:
            "The last name field may only contain alphabetic characters as well as spaces",
        minMust: "must be at least 3 characters",
        must_be_a_valid_email: "Must be a valid email",
        currentPassword:
            "current password must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character",
        newPassword:
            "new password must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character",
        currentPasswordValid:
            "The current password field must be at least 8 characters",
        newPasswordValid:
            "The new password field must be at least 8 characters",
        please_wait_before_resending_email:
            "Please check your email. If you haven't received it, you can resend the verification email after 1 minute.",
    },
    companyErrorMessage: {
        phoneNumberValid:
            "The phone number field must be at least 10 characters",
        Something_went_wrong_Please_contact_to_admin:
            "Something went wrong. Please contact to admin",
    },
    errorPage: {
        project_name: "Project name",
        project_key: "Project key",
        project_category: "Project category",
        team_name: "team name",
        The: "The",
        field_must_be_a_valid: "field must be a valid",
        email: "email",
        password: "Password",
        first_name: "first name",
        last_name: "last name",
        company_name: "company name",
        file_extension: "file extension",
        milestone_status: "milestone status",
        name: "name",
        phone_number: "phone number",
        field_must_be_at_least: "field must be at least",
        number: "number",
        characters: "characters",
        digits: "digits",
        priority_name: "priority name",
        firstName: "first name",
        lastName: "last name",
        phoneNumber: "phone number",
        amount: "amount",
        phone: "phone",
        country: "Country",
        state: "State",
        city: "City",
        templatename: "templatename",
        description: "description",
        Template_name_is_required: "Template name is required",
        "This_template_name_is_required.": "This template name is required.",
        status: "status",
        zipcode: "zipcode",
        address2: "address2",
        address1: "address1",
        The_confirm_password_field_is_required:
            "The confirm password field is required",
        The_confirm_password_confirmation_does_not_match:
            "The confirm password confirmation does not match",
        terms_and_condition: "terms and condition",
        category_name: "Category Name",
        channel_name: "Channel Name",
        amount_per_hours: "amount per hours",
        refundamount: "refund amount",
        please_select_template: "Please select template",
        template_name_already_exists: "Template name is already exist",
        select_a_date: "Select a date",
        must_be_less_than: "must be less than ",
        project_duedate: "Project Due Date",
        project_lead_assignee: "Project Lead Assignee",
        current_password: "Current Password",
        new_password: "New Password",
        confirm_password: "Confirm Password",
        This_template_name_is_already_exists:
            "This template name is already exists.",
        card_name: "card name",
        topic: "topic",
        target_audience: "target audience",
        keywords: "keywords",
        content_purpose: "content purpose",
        "product/service": "product/service",
        campaign_goals: "campaign goals",
        value_proposition: "value proposition",
        objectives: "objectives",
        key_message: "key message",
        problem: "problem",
        context: "context",
        constraints: "constraints",
        main_keyword: "main keyword",
        secondary_keywords: "secondary keywords",
        content_goal: "content goal",
        keyword_list: "keyword list",
        questions: "questions",
        product_description: "product description",
        feedback_data: "feedback data",
        survey_questions: "survey questions",
        project: "project",
        progress_made: "progress made",
        next_steps: "next steps",
        key_features: "key features",
        client_type: "client type",
        challenges: "challenges",
        results: "results",
        event_type: "event type",
        cta: "cta",
        campaign_objectives: "campaign objectives",
        survey_objectives: "survey objectives",
        column_one_name: "column one name",
        column_two_name: "column two name",
        column_one_data: "column one data",
        column_two_data: "column two data",
        customer_name: "customer name",
        email_purpose: "email purpose",
        talking_points: "talking points",
        product_name: "product name",
        about_the_product: "about the product",
        core_problem_it_solves: "core problem it solves",
        what_makes_it_different: "what makes it different",
        the_product_is: "product is",
        core_differentiators: "core differentiators",
        "product/service_benefits": "product/service benefits",
        call_notes: "call notes",
        call_transcript: "call transcript",
        target_company: "target company",
        use_case: "use case",
        customer_challenges: "customer challenges",
        territories: "territories",
        target_industries: "target industries",
        sales_goals: "sales goals",
        sales_strategies: "sales strategies",
        transcript: "transcript",
        pain_points: "pain points",
        company_type: "company type",
        sales_cycle_stages: "sales cycle stages",
        sales_methodologies: "sales methodologies",
        key_skills: "key skills",
        training_formats: "training formats",
        participants: "participants",
        target_industry: "target industry",
        value_statement: "value statement",
        meeting_type: "meeting type",
        your_talking_points: "your talking points",
        goal: "goal",
        reasons_for_canceling: "reasons for canceling",
        incentive: "incentive",
        unique_selling_points: "unique selling points",
        desired_format: "desired format",
        topics: "topics",
        content: "content",
        stakeholders: "stakeholders",
        sales_notes: "sales notes",
        customer_goals: "customer goals",
        teams_impacted: "teams impacted",
        requirements: "requirements",
        goals_met: "goals met",
        project_stakeholders: "project stakeholders",
        opportunities: "opportunities",
        risks: "risks",
        customer_message: "customer message",
        date_range: "date range",
        project_notes: "project notes",
        project_description: "project description",
        name_of_project: "name of project",
        date_ranges: "date ranges",
        requestor: "requestor",
        requests: "requests",
        reason_for_the_change: "reason for the change",
        expected_impact_of_the_change: "expected impact of the change",
        project_goals: "project goals",
        participant_names: "participant names",
        meeting_time: "meeting time",
        timeline: "timeline",
        deliverables: "deliverables",
        project_goal: "project goal",
        project_scope: "project scope",
        main_task: "main task",
        new_format: "new format",
        original_text: "original text",
        stakeholder_titles: "stakeholder titles",
        article_title: "article title",
        focus_keywords: "focus keywords",
        title_of_the_blog_text: "title of the blog text",
        blog_topic: "blog topic",
        section_title: "section title",
        section_content: "section content",
        section: "section",
        title: "title",
        "title(faq_question)": "title(faq question)",
        issue_description: "issue description",
        code_section: "code section",
        concept: "concept",
        version: "version",
        changes: "changes",
        job_title: "job title",
        your_name: "your name",
        your_skills: "your skills",
        math_question: "math question",
        question: "question",
        thesis_topic: "thesis topic",
        text_to_proofread: "text to proofread",
        text_to_rephrase: "text to rephrase",
        text_to_improve: "text to improve",
        job_description: "job description",
        your_title: "your title",
        your_summary: "your summary",
        pain: "pain",
        agitation: "agitation",
        solution: "solution",
        post_content: "post content",
        product_or_service: "product or service",
        unique_selling_proposition: "unique selling proposition",
        email_to_reply_to: "email to reply to",
        audiences_objectives: "audience's objectives",
        sales_teams_roles: "sales team's roles",
    },
    Auth: {
        email: "Email",
        password: "Password",
        firstName: "First Name",
        lastName: "Last Name",
        phoneNumber: "Phone Number",
        login_descriptioon: "See what is going on with your business",
        login_statement: "Login to your Account",
        email_id: "Email ID",
        Password: "Password",
        Conform_pass: "Confirm Password",
        RememberMeL: "Remember Me",
        Remember_password: "Remember password",
        Forgot_Password: "Forgot Password",
        loading: "Loading",
        loging: "Login",
        Register: "Register",
        NotR: "Not registered yet",
        createAcc: "Create an Account",
        alredyacc: "Already have an account?",
        ResendEmail: "Resend Email",
        pleasecheck:
            "Please check your email, If you didn't receive it or misplaced it, please click below to resend the email.",
        backlogin: "Back to Login",
        two_factor_title: "Two-factor authentication",
        two_factor_hint: "Enter the 6-digit code from your authenticator app.",
        two_factor_recovery_hint: "Enter one of your saved recovery codes.",
        two_factor_code_label: "Authentication code",
        two_factor_recovery_label: "Recovery code",
        two_factor_verify: "Verify",
        two_factor_use_recovery: "Use a recovery code instead",
        two_factor_use_app: "Use your authenticator app instead",
        two_factor_enter_code: "Please enter your code",
        two_factor_invalid_code: "That code is not valid. Try again or use a recovery code.",
        two_factor_session_expired: "Your verification session expired. Please sign in again.",
        Welcome_Msg: "Welcome to BRAND_NAME",
        Welcome_Description:
            "Get access to exclusive features by creating an account",
        agree: "I agree to the",
        tearm: "Terms of Service",
        and: "and",
        Privacy_Policy: "Privacy Policy",
        forgatepasswordmsg:
            "Enter the email associated with your account and we’ll send an email with instructions to reset your password.",
        ltitle: "Work on big ideas, without the busywork.",
        time_format: "Time Format",
        timezone: "Timezone",
        selectLanguage: "Select Language",
        check_credentials: "Please check your credentials.",
        check_smtp_credentials: "Please check your SMTP credentials.",
        smtp_successfully_verified: "Your SMTP is successfully verified.",
        verification_code_invalid: "Your verification code is invalid.",
        verification_code_invalid_check_code:
            "Your verification code is invalid. Please check your code.",
        verification_mail_sent:
            "Verification mail has been sent successfully. Please check your inbox.",
        no_account_found_for_email: "No account found for given email.",
        verify_email_and_try_again: "Verify your email and try again.",
        confirm_password: "Confirm Password",
        enter_new_password: "Please enter your new password",
        link_expired_resend_email: "Your link has expired.",
        reset_password: "Reset Password",
        resend_verification_email:
            "Please click on button to resend verification email",
        link_expired: "This link is expired",
        too_many_request:
            "You have sent too many requests in a given amount of time. Please wait and try again later.",
        previous_wasnot_valid:
            "Your previous password wasn't valid. Kindly verify and try again.",
        password_wasnot_valid:
            "Your new password wasn't valid. Please try again.",
        set_new_password: "Set New Password",
        verification_link_expired: "This verification link has expired.",
        verification_link_expired_message:
            "Please check your inbox for the latest verification email. If you haven't received it, try logging in again to request a new one.",
        oAuthGoogleBtnText: "Continue with Google",
    },
    Home: {
        unlock: "Unlock",
        lock: "Lock",
        dashboardLockSuccess: "Dashboard locked successfully",
        dashboardUnlockSuccess: "Dashboard unlocked successfully",
        Home: "Home",
        My_Work: "My Work",
        Done: "Done",
        To_Do: "To Do",
        no_task_found: "No task found",
        Confirm: "Confirm",
        tourclose:
            "Are you certain you want to close this tour? If you confirm, you will not be able to access this tour guide again.",
        Queue_List: "Queue List",
        AddtoQueue: "Add to Queue",
        noquelist: "No queue list found",
        Due_Date: "Due Date",
        createQueueTitle: "Create Queue",
        Today: "Today",
        Calendar: "Calendar",
        Hide: "Hide",
        Overdue: "Overdue",
        Next: "Next",
        Unscheduled: "Unscheduled",
        task_assign_to_you: "task assign to you",
        Notification_Request: "Notification Request",
        no: "No",
        yes: "Yes",
        add_task_type: "Add Task Type",
        are_you_sure: "Do you want to enable browser notifications?",
    },
    Portfolio: {
        new: "New portfolio",
        none: "No portfolios yet.",
        pick: "Select a portfolio to see its rollup.",
        projects: "Projects",
        progress: "Progress",
        on_track: "On track",
        at_risk: "At risk",
        off_track: "Off track",
        overdue: "overdue",
        edit: "Edit",
        delete: "Delete",
        done: "done",
        milestones: "milestones",
        past_due: "past due",
        no_projects: "This portfolio has no accessible projects.",
        h_on_track: "On track",
        h_at_risk: "At risk",
        h_off_track: "Off track",
        name_ph: "Portfolio name",
        saving: "Saving…",
        save: "Save",
        cancel: "Cancel",
        no_company_projects: "No projects available.",
    },
    CustomReport: {
        group_by: "Group by",
        measure: "Measure",
        chart: "Chart",
        project: "Project filter",
        all_projects: "All projects",
        d_status: "Status",
        d_project: "Project",
        d_sprint: "Sprint",
        m_count: "Task count",
        m_points: "Story points",
        c_bar: "Bar",
        c_pie: "Pie (share)",
        c_table: "Table",
        save: "Save report",
        name_ph: "Report name",
        saving: "Saving…",
        saved_list: "Saved reports",
        none_saved: "No saved reports yet.",
        delete: "Delete",
        duplicate: "Duplicate",
        start_from_template: "Start from a template",
        choose_template: "Choose a template…",
        schedules: "Scheduled emails",
        pick_report: "Pick a saved report…",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        recipients_ph: "Recipient emails (comma-separated)",
        schedule_it: "Schedule",
        no_schedules: "No scheduled deliveries yet.",
        recipients_short: "recipient(s)",
        send_now: "Send now",
        share: "Share",
        copy: "Copy",
        revoke: "Revoke",
        generating: "Generating link…",
        no_data: "No data for this configuration.",
        total: "Total",
        export_csv: "Export CSV",
        export_excel: "Export Excel",
    },
    VarianceReport: {
        select_project: "Select a project…",
        pick: "Select a project to see its estimate-vs-actual variance.",
        estimated: "Estimated",
        actual: "Actual",
        variance: "Variance",
        over: "Over",
        under: "Under",
        task: "Task",
        status: "Status",
        no_tasks: "No tasks in this project.",
        s_over: "Over",
        s_under: "Under",
        s_on_track: "On track",
        s_no_estimate: "No estimate",
        export_csv: "Export CSV",
        export_excel: "Export Excel",
    },
    IntegrationsHub: {
        title: "Integrations & Automation",
        soon: "Coming soon",
        active: "Active",
        paused: "Paused",
        received: "received",
        copy: "Copy",
        pause: "Pause",
        resume: "Resume",
        delete: "Delete",
        creating: "Creating…",
        emailToTask: "Email to Task",
        emailToTask_sub: "Turn incoming email into tasks",
        automations: "Automations",
        automations_sub: "When-this-then-that rules",
        calendar: "Calendar",
        calendar_sub: "Sync due dates to your calendar",
        marketplace: "Marketplace",
        marketplace_sub: "Browse available integrations",
        slack: "Slack",
        slack_sub: "Slash commands & notifications",
        apps: "Apps",
        apps_sub: "Embed external tools",
        email_intro: "Create a unique email address for a project. Anything sent to it becomes a task — great for forwarding requests, bug reports or supplier emails.",
        email_pick_project: "Project",
        email_select: "Select a project…",
        email_create: "Create inbox",
        email_note: "Tasks land in the project's first sprint, created as the inbox owner.",
        email_none: "No inboxes yet. Pick a project above to create one.",
        email_address: "Inbox email address",
        email_webhook: "Provider webhook URL",
        email_help_title: "How to connect your email provider",
        email_help_1: "In your inbound email provider (Mailgun, SendGrid, SES, Postmark…), add a route/parse rule for the inbox address above.",
        email_help_2: "Point that route to POST the parsed email to the provider webhook URL above.",
        email_help_3: "Send a test email — a task appears in the project within seconds.",
        cal_intro: "Subscribe to a live calendar of task due-dates in Google Calendar, Outlook or Apple Calendar. Read-only and always up to date.",
        cal_scope: "What to include",
        cal_my: "My tasks",
        cal_project: "A project's tasks",
        cal_create: "Create feed",
        cal_none: "No calendar feeds yet.",
        cal_url: "Calendar subscription URL (iCal)",
        cal_help_title: "How to subscribe",
        cal_help_1: "Copy the subscription URL above.",
        cal_help_2: "In Google/Outlook/Apple Calendar, choose 'Add from URL' (or 'Subscribe to calendar') and paste it.",
        auto_intro: "Define a rule once, then apply it to every matching task in one click — e.g. bump all low-priority tasks in a project to high.",
        auto_name: "Rule name",
        auto_name_ph: "e.g. Escalate stale low-priority",
        auto_when: "When a task matches",
        auto_any_project: "Any project",
        auto_any_priority: "Any priority",
        auto_then: "Then set priority to",
        auto_create: "Create rule",
        auto_none: "No automation rules yet.",
        auto_affected: "affected last run",
        auto_apply: "Apply now",
        connected: "Connected",
        mp_intro: "Connect Hyphen OI Pro to the tools your team already uses.",
        mp_search: "Search integrations…",
        mp_connect: "Connect",
        mp_reconfigure: "Reconfigure",
        mp_disconnect: "Disconnect",
        mp_save: "Save connection",
        mp_cancel: "Cancel",
        slack_url: "Slash command request URL",
        slack_hint: "In your Slack app → Slash Commands, create /hyphen-oi-pro and paste this Request URL. Put your app's Verification Token (Basic Information) in the field above.",
        slack_intro: "Run /hyphen-oi-pro slash commands from your Slack workspace. No OAuth — just paste your app's verification token and add the request URL below.",
        slack_token: "Slack verification token",
        slack_channel: "Default channel (optional)",
        slack_connect: "Connect Slack",
        slack_commands: "Available commands: /hyphen-oi-pro help · /hyphen-oi-pro projects",
        slack_help_title: "How to set it up",
        slack_help_1: "At api.slack.com/apps open (or create) your app → Basic Information → copy the Verification Token into the field above and save.",
        slack_help_2: "Features → Slash Commands → Create New Command: /hyphen-oi-pro, and paste the Request URL shown above.",
        slack_help_3: "In Slack, run /hyphen-oi-pro help to confirm it's connected.",
        apps_intro: "Embed an external tool (dashboard, docs, BI board) as an in-app panel. https URLs only.",
        apps_name: "App name",
        apps_url: "Embed URL (https://…)",
        apps_add: "Add app",
        apps_note: "The embedded site must allow being framed (some set X-Frame-Options / frame-ancestors to block it).",
        apps_none: "No embedded apps yet. Add one above.",
    },
    Capacity: {
        apply: "Apply",
        hours_per_day: "Working hours per day",
        members: "Members",
        member: "Member",
        capacity: "Capacity (h)",
        pto: "PTO (h)",
        allocated: "Allocated (h)",
        utilization: "Utilization",
        over: "Over-allocated",
        status: "Status",
        no_members: "No team members found.",
        loading: "Loading…",
        s_under: "Under",
        s_full: "Full",
        s_over: "Over",
    },
    Header: {
        Project_Forecasting: "Project Forecasting (Coming soon)",
        Resource_Planning: "Resource Planning (Coming soon)",
        Projects: "Projects",
        Portfolio: "Portfolio",
        Custom_Report: "Custom Report",
        Variance_Report: "Variance Report",
        Capacity_Planning: "Capacity Planning",
        Integrations: "Integrations",
        Workspace: "Workspace",
        Time_Sheet: "Time Sheet",
        User_Timesheet: "User Timesheet",
        project_Timesheet: "Project Timesheet",
        Workload_Timesheet: "Workload Timesheet",
        Tracker_Timesheet: "Tracker Timesheet",
        Time_Forcasting: "Time Forecasting",
        Reports: "Reports",
        Milestone_Report: "Milestone Report",
        Chat: "Chat",
        Notification: "Notification",
        mention: "Mention",
        Tours: "Tours",
        Logout: "Logout",
        Mark_all_as_read: "Mark all as read",
        Mark_all_as_complete: "Mark all as Complete",
        View_Archive: "View Archive",
        View_Unread: "View Unread",
        designation: "Designation",
        upgrade_now: "Upgrade Now",
        load_more: "Load more",
        take_tour: "Take a Tour",
        task_details: "Task Details",
        Comments: "Comments",
        activity_log: "Activity Log",
        time_log: "Time Log",
        mentions: "Mentions",
        Notifications: "Notifications",
        no_data_found: "No Data Found",
        search_results: "Search results",
        my_profile: "My Profile",
        billing_history: "Billing History",
        Assignee: "Assignee",
        "Due Date": "Due Date",
        Priority: "Priority",
        Key: "Key",
        "Created Date": "Created Date",
        "Created By": "Created By",
        advance_search: "Advance Search",
        for_advance_search: "For Advance Search",
        get_more: "Get more?",
        to_unlock_activity_view: "To Unlock Activity View",
        AssigneeUserId: "Assignee",
        DueDate: "Due Date",
        TaskKey: "Key",
        Task_Priority: "Priority",
        commentCounts: "Chat",
        created_by: "Created By",
        created_date: "Created Date",
        create_project: "Create Project",
        Company: "Company",
    },
    ProjectDetails: {
        select_project_category: "Select Project Category",
        select_currency: "Select Currency",
        description: "Description",
        details: "Details",
        status: "Status",
        assignee: "Assignee",
        key: "Key",
        category: "Category",
        source: "Source",
        type: "Type",
        billing_period: "Billing Period",
        currency: "Currency",
        amount: "Amount",
        proposal_id: "Proposal ID",
        skills: "Skills",
        no_skills: "No Skills",
        no_skills_configured: "No skills have been added in company settings yet.",
        skills_limit: "Up to {count} skills per project.",
        start_date: "Start Date",
        end_date: "End Date",
        no_start_date: "No Start Date",
        no_end_date: "No End Date",
        no_due_date: "No Due Date",
        msg: "The start date can't be modify because it is already",
        msgbr: "within a milestone range.",
        startdatemsg0: "The start date can't be modify because it is already",
        startdatemsg1: "within a milestone range.",
        ok: "ok",
        lead: "Lead",
        browse_by_category: "Browse by category",
        subtask: "Subtask",
        details_project_setup: "Details of the Project set up",
        avatar: "Avatar",
        shared_with: "Shared with",
        no_user_selected: "No Users Selected",
        required_view: "Required views",
        set_the_require:
            "Set the view(s) you require. These views will be automatically when you are navigating to Projects, Folders, and Lists in BRAND_NAME instead of manually creating them. Once created, views cannot be deleted.",
        always_required: "Always Required",
        make_default: "Make Default",
        reporter: "Reporter",
        copy_task_link: "Copy Task Link",
        copy_task_key: "Copy Task Key",
        remind_me: "Remind me",
        reminder_when: "Remind me at",
        reminder_note: "Note (optional)",
        reminder_set: "Reminder set",
        reminder_failed: "Could not set reminder",
        add_que_list: "Add to Queue List",
        remove_que_list: "Remove to Queue List",
        convert_list: "Convert to List",
        convert_subtask: "Convert to Subtask",
        merge: "Merge",
        move: "Move",
        convert_task: "Convert to Task",
        no_currency_found: "no currency found",
        remove_from_queue_list: "Remove from Queue List",
        convert: "Convert",
        DUPLICATE_AND_OPEN: "Duplicate and Open",
        MOVE_AND_OPEN: "Move and Open",
        CONVERT_AND_OPEN: "Convert and Open",
        MERGE_AND_OPEN: "Merge and Open",
    },
    ProjectSlider: {
        new_project: "New Project",
        no_archived: "No Archived Data Found",
        you_dont: "You don't have any projects",
        archived_list: "Archived List",
        projects: "Projects",
        project_name: "Project Name",
        folder_name: "Folder Name",
        sprint_name: "Sprint Name",
        show_archive: "Show Archive",
        hide_archive: "Hide Archive",
        try_using_diff: "Try using different keywords",
        no_project_found: "No projects found",
        no_result_found: "No Results found",
        select_project_status: "Select Project Status",
        no_activity_log_found: "No activity log found",
    },
    Projects: {
        select_source: "Select Source",
        source_upwork: "Upwork",
        source_fiverr: "Fiverr",
        source_other: "Other",
        source_required: "Select where this project came from.",
        proposal_id_required_upwork: "A proposal ID is required for Upwork projects.",
        proposal_id_format_hint: "Paste the id from the proposal URL — the '~' prefix and trailing '/' are removed for you.",
        proposal_id_format_warning: "That doesn't look like an Upwork proposal ID. It will still be saved.",
        sprint: "Sprint",
        folder: "Folder",
        task_view: "Task View",
        default_view: "Default View",
        add_view: "Add View",
        rename: "Rename",
        pin: "Pin",
        edit_code: "Edit Code",
        copy_link: "Copy Link",
        delete: "Delete",
        view: "View",
        watchers: "Watchers",
        files_links: "Files & Links",
        audio_files: "Audio Files",
        project_permissions: "Project Permissions",
        color_avatar: "Color & Avatar",
        duplicate: "Duplicate",
        close_project: "Close Project",
        archive: "Archive",
        search_in: "Search In",
        expanded: "Expanded",
        collapsed: "Collapsed",
        me: "Me",
        status: "Status",
        priority: "Priority",
        due_date: "Due Date",
        group_by: "Group by",
        subtask: "Subtask",
        task_name: "Task Name",
        task_key: "Task key",
        everyone: "Everyone",
        private: "Private",
        share_with: "Share With",
        create_new_list: "Create New Sprint",
        create_new_folder: "Create New Folder",
        restore: "Restore",
        unpin: "Unpin View",
        pinview: "Pin View",
        deleteview: "Delete View",
        close: "Close",
        cancel: "Cancel",
        tasks: "Tasks",
        save: "Save",
        create_project: "Create Project",
        use_template: "Use Template",
        blank_project: "Blank Project",
        no_category_found: "No category found",
        template: "Template",
        save_create: "Save & Create",
        save_tamplete: "Save as Template",
        previous: "Previous",
        new_task: "New Task",
        sprint_planned: "Planned",
        sprint_logged: "Logged",
        sprint_overdue: "Overdue",
        sprint_planned_hint: "Hours planned across every task in this sprint, subtasks included",
        sprint_logged_hint: "Hours logged across every task in this sprint, subtasks included",
        sprint_overdue_hint: "How far this sprint is on course to run past its plan. Finished tasks count what they actually logged; unfinished ones count their plan, or the time already spent if that is more.",
        add_subtask: "Add Subtask",
        linked_tasks: "Linked Tasks",
        add_link: "Link Task",
        remove_link: "Remove link",
        no_linked_tasks: "No linked tasks yet",
        search_task_to_link: "Search task by name...",
        no_task_found: "No matching task found",
        searching: "Searching...",
        link_task_deleted: "deleted",
        link_task_unavailable: "Task unavailable",
        relation_blocks: "Blocks",
        relation_blocked_by: "Blocked by",
        relation_duplicates: "Duplicates",
        relation_duplicated_by: "Duplicated by",
        relation_relates_to: "Relates to",
        blocked_warning: "Blocked by {count} open task(s):",
        add_reaction: "Add reaction",
        burndown: "Burndown",
        select_sprint: "Sprint",
        no_burndown_data: "No data for this sprint yet",
        recent_tasks: "Recent",
        no_recent_tasks: "No recently visited tasks",
        global_search: "Search all",
        search_everything: "Search tasks, projects and comments...",
        no_search_results: "Nothing found",
        epics: "Epics",
        add_epic: "Add",
        epic_name_placeholder: "New epic name...",
        no_epics: "No epics yet",
        select_epic: "Add to epic",
        epic_priority: "Priority",
        priority_low: "Low",
        priority_medium: "Medium",
        priority_high: "High",
        epic_start_date: "Start",
        epic_due_date: "Due",
        epic_owner: "Owner",
        epic_unassigned: "Unassigned",
        epic_status_open: "Open",
        epic_status_in_progress: "In progress",
        epic_status_done: "Done",
        remove_from_epic: "Remove from epic",
        export_tasks: "Export",
        export_preparing: "Export started — preparing your file...",
        export_ready: "Export ready — downloading",
        export_failed: "Export failed",
        pages: "Docs",
        add_page: "New doc",
        add_sub_page: "Add a sub-page",
        search_pages: "Search docs…",
        no_pages: "No docs yet",
        no_pages_match: "No doc matches that search.",
        select_page: "Pick a doc on the left, or start a new one.",
        save_page: "Save",
        page_saving: "Saving…",
        page_saved: "All changes saved",
        doc_private: "Private",
        doc_shared: "Shared",
        doc_private_hint: "Only you can see this doc",
        doc_shared_hint: "Everyone on this project can see this doc",
        doc_share_title: "Share this doc",
        doc_public_link: "Share link with anyone",
        doc_public_link_hint: "Anyone with the link can read this doc — no login needed",
        doc_public_needs_shared: "Set the doc to Shared first",
        doc_copy_public_link: "Copy public link",
        doc_link_tasks: "Link tasks",
        doc_linked_tasks: "Linked tasks",
        doc_unlink: "Unlink",
        doc_no_linked_tasks: "Not linked to any task yet",
        linked_docs: "Linked Docs",
        task_no_docs: "No docs linked to this task",
        task_link_doc: "Link a doc",
        doc_all_linked: "Every doc in this project is already linked.",
        page_title_placeholder: "Doc title",
        doc_create_hint: "The doc is linked to this task and opens for editing.",
        create: "Create",
        page_unsaved: "Unsaved changes",
        page_edited_by: "Edited by {who} on {when}",
        page_discard_confirm: "This doc has unsaved changes. Leave without saving?",
        page_delete_confirm: "Delete this doc? This cannot be undone.",
        page_delete_with_children: "Delete this doc and every sub-page under it? This cannot be undone.",
        untitled_page: "Untitled doc",
        edit: "Edit",
        preview: "Preview",
        search_task: "Search task by name or key...",
        no_tasks_found: "No tasks found",
        unknown_status: "Unknown",
        public_link: "Public link",
        create_public_link: "Create public link",
        move_to_folder: "Move to folder",
        no_folder_root: "No folder (root)",
        select_folder: "Select a folder to move this sprint into",
        link_enabled: "Link enabled",
        allow_intake: "Accept public requests",
        expires_optional: "Expires (optional)",
        password_optional: "Password (optional)",
        delete_link: "Delete link",
        password_protected: "Password protected",
        share_expires_on: "Expires",
        intake_inbox: "Requests",
        no_intake: "No pending requests",
        anonymous: "Anonymous",
        accept: "Accept",
        reject: "Reject",
        import_jira: "Import Jira",
        import_jira_hint: "Upload a Jira CSV export (Summary, Status, Priority, Due date, Description). Tasks land in the selected sprint with mapped statuses.",
        import_rows_found: "{count} rows detected",
        import_no_rows: "No rows found in that file",
        importing: "Importing...",
        start_import: "Import",
        download_sample: "Download sample file",
        import_csv: "Import CSV",
        import_csv_hint: "Upload a CSV/XLSX file, map your columns, and tasks land in the selected sprint.",
        import_trello: "Import Trello",
        import_trello_hint: "Upload a Trello board JSON export (board Menu → Print/Export → Export as JSON). Lists map to statuses; cards become tasks.",
        import_trello_found: "{lists} lists, {cards} cards detected",
        import_trello_invalid: "That does not look like a Trello board JSON export",
        import_asana: "Import Asana",
        import_asana_hint: "Upload an Asana project JSON export (Project menu → Export/Print → JSON). Sections map to statuses; tasks land in the selected sprint. Subtasks are skipped.",
        import_asana_found: "{tasks} tasks detected",
        import_asana_invalid: "That does not look like an Asana JSON export",
        import_monday: "Import Monday.com",
        import_monday_hint: "Upload a Monday.com board export (Board menu → Export board to Excel), map your columns, and tasks land in the selected sprint.",
        map_columns: "Map your columns",
        col_task_name: "Task name",
        col_status: "Status",
        col_priority: "Priority",
        col_due: "Due date",
        col_description: "Description",
        col_none: "— none —",
        auto_archive: "Auto-archive",
        more_features: "More",
        export_hint: "Download this project's tasks as a file.",
        auto_archive_hint: "Completed tasks untouched for the chosen number of days are archived automatically every night.",
        auto_archive_enable: "Enable auto-archive for this project",
        auto_archive_after: "Archive after",
        days: "days",
        list_of_user: "List Of User",
        list_of_project_status: "List of Project Status",
        list_of_task_type: "List of Task Type",
        list_of_task_status: "List of Task Status",
        list_cc: "List cc",
        category_list: "Category List",
        created_by: "Created by",
        tags: "Tags",
        task_type: "Task Type",
        workspace: "Workspace",
        project_color: "Project Color",
        search: "Search",
        add_task_need: "Add the type of tasks you need",
        what_task_want: "What task type do you want",
        no_sub_tasks_found: "No sub tasks found",
        all_project: "All Project",
        closed_project: "Closed Project",
        go_to_project: "Go to Projects",
        reopen_project: "Reopen Project",
        required_view: "Required Views",
        project_status: "Add the statuses for the project",
        what_project: "What project status do you want",
        active_status: "Active Status",
        done_status: "Done Status",
        add_status: "Add Status",
        close_status: "Close Status",
        submit: "Submit",
        Audio_Files: "Audio Files",
        "Files_&_Links": "Files & Links",
        no_audio_file: "No audio files found",
        change_color: "Change color & avatar",
        files: "Files",
        links: "Links",
        about: "About",
        result: "results",
        seconds: "seconds",
        sort_by: "Sort by",
        relevance: "Relevance",
        last_update: "Last Updated",
        last_created: "Last Created",
        issue: "Issue",
        update: "Update",
        date: "Date",
        time: "Time",
        duration: "Duration",
        duplicate_task: "Duplicate Task",
        projects: "Projects",
        browse_projects: "Browse Projects",
        location: "Location",
        add_new: "Add New",
        create_compnay: "Create Company",
        company_name: "Company Name",
        archived_project: "Archived Project",
        assignee_teams: "Teams",
        assignee_user: "Users",
        all: "All",
        restore_project: "Restore Project",
        delete_project: "Delete Project",
        items_per_page: "Items Per Page",
        Assignee: "Assignee",
        Project_Created_Date: "Project Created Date",
        Project_Status: "Project Status",
        Project_Type: "Project Type",
        Comments_Counts: "Comments Counts",
        Created_Date: "Created Date",
        Name: "Name",
        Running_Time_Tracker: "Running Time Tracker",
        Assigned_to: "Assigned to",
        Project: "Project",
        Currency: "Currency",
        Milestone_Type: "Milestone Type",
        Project_Category: "Project Category",
        Comment_Type: "Comment Type",
        results_in_time: "Results in",
        create_blank_project: "Create Blank Project",
        create_project_using_template: "Create Project Using Template",
        choose_apps: "Choose Apps",
    },
    Watcher: {
        ignore: "Ignore",
        participating_mentions: "Participating and {'@'}mentions",
        list_of_watcher: "List of Watcher",
        all_activity: "All Activity",
        watchers_list: "Watchers list",
        owner: "Owner",
    },
    ViewList: {
        List: "List",
        Board: "Board",
        "Project Details": "Project Details",
        Comments: "Comments",
        Calendar: "Calendar",
        Activity: "Activity",
        Workload: "Workload",
        Dashboard: "Dashboard",
        Gantt: "Gantt",
        Table: "Table",
        Timeline: "Timeline",
        Embed: "Embed",
        Reports: "Reports",
        GanttView: "Gantt",
        RecurringTasks: "Recurring Tasks",
        TimelineView: "Timeline",
        MindMapView: "Mind Map",
        WhiteboardView: "Whiteboard",
        CanvasView: "Canvas",
        MapView: "Map",
        // The catalog/tab labels key off the DB record's `name` field
        // ($t(`ViewList.${item.name}`)), so the KEYS must match those names verbatim.
        // The VALUES are the short display labels (no "View" suffix).
        "Gantt View": "Gantt",
        "Recurring Tasks": "Recurring Tasks",
        "Timeline View": "Timeline",
        "Mind Map View": "Mind Map",
        "Whiteboard View": "Whiteboard",
        "Canvas View": "Canvas",
        "Map View": "Map",
        Comment: "Comment",
        to_unlock_list_view: "To Unlock List View",
        error_message_for_empty: "Please select at least one view",
        set_as_default: "Set as Default",
        remove_as_default: "Remove as Default",
    },
    Apps: {
        tags: "Tags",
        Priority: "Priority",
        TimeEstimates: "Time Estimate",
        Milestones: "Milestones",
        MultipleAssignees: "Multiple Assignees",
        CustomFields: "Custom Fields",
        TimeTracking: "Time Tracking",
        AI: "AI",
    },
    Tags: {
        no_tags_found: "No Tags Found",
        search_or_create_new: "Search or Create New",
        change_color: "Change Color",
        delete_tag: "Delete Tag",
        delete_tag_desc:
            "Are you sure you want to delete the tag everywhere in this Space?",
        note_msg: "Press Enter to create a new tag",
        This_tag_has_already_been_added: "This tag has already been added",
        Tag_name_required: "Tag name required",
    },
    Embeded: {
        Anything: "Anything",
        Sheets: "Google Sheets",
        Docs: "Google Docs",
        Youtube: "Youtube",
        Figma: "Figma",
        The_name_is_required: "The name is required",
        The_name_should_be_at_least_3_characters_long:
            "The name should be at least 3 characters long",
        The_url_is_required: "The url is required",
        Please_enter_valid_url: "Please enter valid url",
        URL_already_exists: "URL already exists",
        The_Html_code_is_required: "The Html code is required",
        name_already_exists: "This name already exists",
        to_unlock_embed_view: "To Unlock Embed View",
    },
    ViewListdescription: {
        timeline_view:
            "See your scheduled tasks laid out on a shared date axis to spot overlaps and gaps at a glance.",
        mindmap_view:
            "Visualize the project as a mind map — parent tasks branching into their subtasks.",
        whiteboard_view:
            "Arrange tasks as free-floating cards on a board — drag them anywhere to map out your thinking.",
        canvas_view:
            "A configurable dashboard of project widgets — status, priority, progress, overdue and upcoming work.",
        map_view:
            "Pin tasks onto a world map to see where your work happens — placements are saved to your browser.",
        dashboard_view:
            "A project overview at a glance — task totals, completion, and estimated vs remaining hours, scoped to your role.",
        list_view:
            "Use List view to organize your tasks in anyway imaginable – sort, filter, group, and customize columns.",
        kanban_view:
            "Build your perfect Board and easily drag-and-drop tasks between columns.",
        projectdetail_view:
            "Add Initial requirements, Checklist and attachments for your team to understand in details.",
        Comments_view:
            "Add comments in real-time about anything with your team so they get notified and can reply with the response.",
        calender_view:
            "Calendar view is your place for planning, scheduling, and resource management.",
        table_view:
            "Easily manage, update, and organize your tasks with Table view.",
        workload_view:
            "See your team's capacity, who is over or under and reassign tasks accordingly.",
        activitylog_view:
            "Get an aggregated view of all activity across a location. Filter for people and type to get granular with the activity you see.",
        reports_view:
            "Track sprint progress with burndown, velocity, and cumulative flow charts — and export them as branded PDFs.",
        gantt_view:
            "Plan and schedule work on a timeline — drag bars to reschedule, link task dependencies, and see the whole project at a glance.",
        recurring_view:
            "Automate repeating work — define tasks that recreate themselves on a daily, weekly, or monthly schedule.",
        add_msg1: "Add apps and websites alongside your tasks with Embed view",
        add_msg2: "to save time and reduce context switching.",
        view_name: "View Name",
        embed_URL: "Embed URL",
        embed_HTML: "Embed HTML",
        private_view: "Private view",
    },
    projectDashboard: {
        total_tasks: "Total Tasks",
        completed_tasks: "Completed Tasks",
        unassigned_tasks: "Unassigned Tasks",
        completion_ratio: "Task Completion",
        completed: "Completed",
        remaining: "Remaining",
        overall_completion: "Overall Completion",
        by_effort: "By logged vs estimated hours",
        estimate_hours: "Estimate Hours",
        logged: "Logged",
        failed: "Couldn't load the dashboard",
        retry: "Retry",
        by_person: "By Person",
        person: "Person",
        tasks: "Tasks",
        estimated: "Estimated",
        overdue: "Overdue",
        completion: "Completion",
        showing: "Showing",
        click_to_filter: "Click a person to filter",
        calc_note: "Counts include tasks and subtasks, and each task is counted once in the totals. In the By-Person breakdown a task shared by several people appears under each of them, so those rows can add up to more than the total. Unassigned tasks are grouped under \"Unassigned\". Estimated / Logged / Remaining hours roll up from parent tasks.",
    },
    TalkToText: {
        title: "Talk to Text",
        microphone: "Microphone",
        default_mic: "Default microphone",
        mic_n: "Microphone {n}",
        start: "Start Recording",
        stop: "Stop",
        cancel: "Cancel",
        transcribing: "Transcribing…",
        complete: "Transcription complete!",
        failed: "Couldn't transcribe",
        failed_hint: "Transcription failed. Please try again.",
        copy: "Copy text",
        copied: "Copied to clipboard",
        create_task: "Create a task",
        record_again: "Record again",
        task_name: "Task name",
        project: "Project",
        sprint: "Sprint",
        select_project: "Select a project",
        select_sprint: "Select a sprint",
        loading: "Loading…",
        back: "Back",
        create: "Create",
        creating: "Creating…",
        name_length: "Task name must be 3–250 characters.",
        pick_project_sprint: "Please select a project and sprint.",
        project_not_ready: "This project isn't set up for tasks yet.",
        mic_denied: "Microphone access was denied or is unavailable.",
        no_audio: "No audio captured. Please try again.",
        unsupported: "Recording isn't supported in this browser.",
        select_project_first: "Select a project first.",
        no_records: "No records found",
    },
    // Main Chat module (components/organisms/MainChat). Kept in its own namespace
    // so the chat UI owns its strings instead of borrowing from Comments.
    call: {
        start_audio: "Start an audio call",
        start_video: "Start a video call",
        incoming_audio: "Incoming audio call",
        incoming_video: "Incoming video call",
        accept: "Accept",
        decline: "Decline",
        hang_up: "Hang up",
        mute: "Mute",
        unmute: "Unmute",
        camera_off: "Turn camera off",
        camera_on: "Turn camera on",
        peer_muted: "Their microphone is off",
        sound_off: "Silence the ringer",
        sound_on: "Turn the ringer back on",
        share_screen: "Share your screen",
        stop_share: "Stop sharing",
        maximize: "Maximise",
        restore: "Restore",
        no_turn_warning: "No TURN relay is configured. Calls may fail to connect on restrictive networks.",
    },
    MainChat: {
        search: "Search in conversation",
        user_info: "View profile",
        channel_info: "Channel details",
        message_channel: "Message #{name}",
        message_direct: "Message {name}",
        send: "Send",
        attach: "Attach a file",
        reply: "Reply",
        copy: "Copy text",
        copied: "Copied to clipboard",
        delete: "Delete message",
        cancel: "Cancel",
        not_sent: "Not sent",
        retry: "Retry",
        load_older: "Load earlier messages",
        loading: "Loading…",
        new_messages: "new",
        jump_latest: "Jump to latest message",
        typing: "typing",
        typing_one: "{name} is typing",
        typing_two: "{first} and {second} are typing",
        typing_many: "{count} people are typing",
        pinned_messages: "Pinned messages",
        pinned_none: "Nothing is pinned in this conversation yet. Pin a message from its ⋮ menu to keep it here.",
        pinned_count: "{count} pinned",
        record: "Record a voice note",
        microphone: "Microphone",
        start_recording: "Start recording",
        recording: "Recording",
        paused: "Paused",
        pause: "Pause",
        resume: "Resume",
        stop_attach: "Stop & attach",
        record_hint: "Stop to attach it, then press Send. Closing this discards the recording.",
        record_unsupported: "Recording is not supported in this browser.",
        mic_denied: "Microphone access was blocked. Allow it in your browser settings and try again.",
        no_audio: "Nothing was recorded. Please try again.",
        read_only: "You cannot post here",
        read_only_channel: "Sending is turned off for this channel. Only owners and admins can post.",
        read_only_direct: "You have read-only access to direct messages.",
        enter_send: "send",
        shift_enter: "new line",
        empty_channel: "No messages in this channel yet",
        empty_direct: "No messages yet",
        empty_hint: "Type below to start the conversation.",
        deleted_by_you: "You deleted this message",
        deleted: "This message was deleted",
        confirm_delete: "Delete this message?",
        confirm_delete_yes: "Delete",
        failed: "Something went wrong. Please try again.",
        you: "You",
        today: "Today",
        yesterday: "Yesterday",
        private_channel: "Private channel",
        photos_media: "Photos & media",
        documents: "Documents",
        nothing_shared: "Nothing shared yet",
        members: "Members",
        email: "Email",
        phone: "Phone",
        timezone: "Time zone",
        start_conversation: "Start a conversation",
        channels: "Channels",
        more: "More actions",
        edit: "Edit message",
        editing: "Editing message",
        save: "Save",
        pin: "Pin message",
        unpin: "Unpin message",
        pinned: "Pinned",
        pinned_ok: "Message pinned",
        unpinned_ok: "Message unpinned",
        mark_unread: "Mark as unread",
        edited: "edited",
        // `@` must be escaped as {'@'}: a bare @ starts vue-i18n's linked-message
        // syntax and fails to compile ("Unexpected empty linked key").
        mention_hint: "Type {'@'} to mention",
        add_reaction: "Add reaction",
        no_matches: "Nothing matches your search",
        // The two tabs search different fields, so each says what it matches on.
        search_people: "Search people by name",
        search_channels: "Search channels or categories",
        // Shown as the author of messages left by someone who has since been
        // removed from the company. Their messages are kept; only the identity is
        // anonymised, so the "Ghost User" placeholder never surfaces in chat.
        former_member: "Former member",
        search_placeholder: "Search messages and files...",
        search_hint: "Search this conversation — message text, or an attachment by its file name.",
        search_none: "No messages or files match your search",
        // Two explicit keys rather than vue-i18n's `a | b` plural form, which needs
        // the count passed as the choice argument and silently picks the wrong
        // branch when it is passed as a named value instead.
        search_result_one: "1 result",
        search_result_many: "{count} results",
        search_not_loaded: "That message is further back in this conversation — load earlier messages to jump to it.",
        unread_one: "1 unread message",
        unread_many: "{count} unread messages",
        marked_unread: "Marked as unread from here",
    },
    Filters: {
        filter: "Filters",
        learnmorefilter: "Learn more about filters",
        pleaseselectvalid: "Please select all valid options",
        confirm: "Confirm",
        are_you_sure: "Are you sure want to delete",
        clearall: "Clear all",
        addfilter: "Add Filter",
        where: "Where",
        filtering_field: "Filtering Field",
        no_date_found: "No date found",
        save_this_filters: "Save this Filters",
        save_filter: "Save Filter",
        save: "Save",
        update_filter: "Update filter",
        my_filter: "My Filter",
        no_data_found: "No data found",
        show_result: "Show Result",
        save_filters: "Save Filters",
        filter_by: "Filter by",
        projects: "Projects",
        teams: "Teams",
        user: "User",
        no_comment_found: "No comment found",
        no_project_found: "No project found",
        no_file_found: "No file found",
        no_link_found: "No link found",
        filter_operator: "Filter Operator",
        options: "Options",
        priorities: "Priorities",
        select_all: "Select All",
        milestone_type: "milestone type",
        comment_type: "Comment Type",
        a_to_z: "A to Z",
        no_files_found: "No files found",
        no_links_found: "No links found",
        no_links_or_files_found: "No links or files found",
        z_to_a: "Z to A",
        sort_by: "Sort By",
        "A-Z": "A-Z",
        Ascending: "Ascending",
        Descending: "Descending",
        No: "No",
        Yes: "Yes",
        "Z-A": "Z-A",
        Save_this_Filter: "Save this Filter",
        Enter_Filter_Name: "Enter Filter Name",
        Select_Options: "Select Options",
        Equal_To: "Equal To",
        Greater_Than: "Greater Than",
        Is: "Is",
        Less_Than: "Less Than",
        Clear_All: "Clear All",
        select_assignee: "Select Assignee",
        select_project_types: "Select Project Types",
        unselect_all: "Unselect All",
        are_you_suredelete: "Are you sure you want to delete?",
        Not_Equals_To: "Is Not",
    },
    conformationmsg: {
        archive:
            "A List can be archived to hide it from view but be restored at any time. All tasks are kept and remain searchable when you archive a List.",
        delete: "This Project's tasks and templates will all be erased. Type project name to confirm that you really do wish to delete all tasks, templates, and this project.",
        archive0mesg:
            "Type project name to confirm that you really do wish to close this project",
        sprintclosemsg:
            "Type sprint name to confirm that you really do wish to close this sprint",
        type: "Type",
        are_you_sure: "Are you sure?",
        no_revert_msg: "You won't able to revert this!",
        yes_delete: "Yes, delete it!",
        task_will_become_subtasks_of: "task will become subtasks of",
        Are_you_sure_you_want_to_delete: "Are you sure you want to delete",
        subtasks_will_become_subtasks_of: "Subtasks will become subtasks of",
        unlock_board_view: "To Unlock Board View",
        unlock_project_detail_view: "To Unlock Project Detail View",
        unlock_table_view: "To Unlock Table View",
        unlock_workload_view: "To Unlock WorkLoad View",
        to_unlock_tracker_timesheet: "To Unlock Tracker Timesheet",
        to_unlock_user_timesheet: "To Unlock User TimeSheet",
        unlock_calendar_view: "To Unlock the Calendar View",
    },
    Description: {
        description: "Description",
        edit: "Edit",
        add_description: "Add a Description",
        show_more: "Show More",
        show_less: "Show Less",
        description_placeholder:
            "Write something or type '/' for commands and AI action",
        saved: "Saved",
    },
    Checklist: {
        checklist: "Checklist",
        add_checklist: "Add an Checklist",
        suggest_checklists: "Suggest Checklists",
        Checklists: "Checklists",
        to_unlock_checklist: "To Unlock Checklist",
    },
    Attachments: {
        attachments: "Attachments",
        drag_file: "Here, you can also drag and drop files.",
        see_all: "See All",
        drop_file: "Drop files here to attach or",
        browse: "Browse",
        no_preview_found: "No preview found",
        show_all_pages: "Show all pages",
        drop_here: "Drop Here",
        // AHE-3838 — cloud attachments (Google Drive / Dropbox)
        upload_from_computer: "Upload from computer",
        attach_from: "Attach from",
        connect_provider: "Connect {provider}",
        provider_not_configured: "{provider} is not set up for this workspace yet. An admin can add it under Settings → Integrations.",
        cloud_link_missing: "This file has no link saved. It may have been removed from the cloud drive.",
        cloud_skipped_in_zip: "{count} linked cloud file(s) were skipped — open them in their drive to download.",
        cloud_linked: "Linked from {provider}",
        cloud_attached: "Attached from {provider}",
        cloud_attach_failed: "Could not attach the selected file(s). Please try again.",
        picker_blocked: "The picker window was blocked. Please allow pop-ups for this site and try again.",
        import_copy: "Import a copy",
        link_file: "Link the file",
        importing: "Importing...",
        import_done: "Imported {name}",
        import_failed: "Could not import from {provider}.",
    },
    ClipRecorder: {
        record_clip: "Record clip",
        voice: "Voice",
        screen: "Screen",
        screen_mic: "Screen + mic",
        start: "Start",
        stop: "Stop",
        re_record: "Re-record",
        attach: "Attach",
        cancel: "Cancel",
        recording: "Recording...",
        permission_denied: "Could not access your camera, microphone or screen. Please grant permission and try again.",
        unsupported: "Recording is not supported in this browser.",
        screen_https_hint: "Screen recording requires a secure (HTTPS) connection. Voice recording is still available.",
        minimize: "Minimize",
        maximize: "Maximize",
        close: "Close",
        minimize_hint: "You can minimize this — recording keeps running in the background while you work.",
        discard_confirm: "Recording in progress. Discard this clip?",
        save: "Save",
        title_label: "Title",
        title_placeholder: "Clip title",
        saving: "Saving...",
        save_failed: "Could not save the clip. Please try again.",
        saved: "Clip saved",
    },
    Clips: {
        title: "Clips",
        my_clips: "My Clips",
        library: "Clip library",
        record_new: "Record new clip",
        play: "Play",
        loading: "Loading clips...",
        empty: "No clips yet. Record one to get started.",
        rename: "Rename",
        rename_placeholder: "Clip title",
        delete: "Delete",
        delete_confirm: "Delete this clip? This cannot be undone.",
        copy_link: "Copy link",
        copied: "Link copied",
        copy_failed: "Could not copy the link.",
        options: "Options",
        video_badge: "Video",
        audio_badge: "Audio",
        deleted: "Clip deleted",
        delete_failed: "Could not delete the clip.",
        rename_failed: "Could not rename the clip.",
        untitled: "Untitled clip",
        hide: "Hide player",
        search: "Search clips",
        search_placeholder: "Search clips…",
        no_results: "No clips match your search.",
        convert_action: "Convert to task",
        convert_title: "Convert clip to task",
        converted_badge: "Converted",
        confirm_delete_title: "Are you sure you want to delete this clip?",
    },
    Milestone: {
        milestone: "Milestone",
        milestone_name: "Milestone Name",
        status_date: "Status Date",
        total_amount: "Total Amount",
        are_you_sure: "Are you sure want to delete milestone",
        add_new: "Add a New",
        mileston_status: "Milestone Status",
        project_name: "Project Name",
        end_date: "End Date",
        start_date: "Start Date",
        estimated_release: "Estimated Release",
        release_request_sent: "Release Request Sent",
        released: "Released",
        not_funded: "Not Funded",
        funded: "Funded",
        project_milestone_Status: "Project Milestone Status",
        milestone_status_name: "Milestone Status Name",
        date_displaye: "Date Displayed in Calendar",
        past: "Past",
        feature: "Future",
        milestone_weekly_range: "Milestone Weekly Range",
        file_extensions: "File Extensions",
        avatar: "Avatar",
        adding_estimated: "Add Estimated Hours",
        range: "Range",
        user: "User",
        refunded_amount: "Refunded Amount",
        Max_2_decimal_places_allowed: "Max 2 decimal places allowed",
        The_refunded_amount_field_should_not_be_more_then_amount:
            "The refunded amount field should not be more then amount",
        Amount_field_should_not_be_smaller_than_the_refunded_amount:
            "Amount field should not be smaller than the refunded amount",
        The_minute_field_must_be_59_or_less:
            "The minute field must be 59 or less",
        The_hours_field_is_required: "The hours field is required",
        Name_already_exists: "Name already exists",
        The_milestone_status_field_is_required:
            "The milestone status field is required",
        The_milestone_status_field_must_be_at_leat_characters:
            "The milestone status field must be at least 3 characters",
        actual_amount: "Actual Amount",
        partially_refunded: "Partially refunded",
        refunded_amount_should_not_exceed_amount:
            "The refunded amount field should not be more than the amount",
        total_partially_refunded: "Total partially refunded",
        field_should_not_be_smaller_than_refund_amount:
            "Field should not be smaller than refund amount",
        white_color_not_allowed:
            "White color is not allowed. Please select a valid color",
        billing: "Billing",
        per_hour: "Per Hour",
        adding_taskPlanning: "Add Task Planning",
    },
    Comment: {
        created_by: "Created by",
        created_on: "Created on",
        task_name: "Task name",
    },
    UserTimesheet: {
        back_projects: "Back to Projects",
        user_timesheet: "User Timesheet",
        back: "Back",
        tracked_time: "Tracked Time",
        manual_time: "Manual Time",
        users: "Users",
        logged: "Logged",
        hours: "Hours",
        estimated: "Estimated",
        no_records_found: "No records found",
        project_timesheet: "Project Timesheet",
        tracker_timesheet: "Tracker Timesheet",
        workload_timesheet: "Workload Timesheet",
        milestone_reports: "Milestone Reports",
        add_time: "Add Time",
        add_time_log: "Add Time Log",
        edit_time_log: "Edit Time Log",
        Teams: "Teams",
        Users: "Users",
        Projects: "Projects",
        task_planning: "Task Planning",
        task_remaining_planning: "Remaining Hours",
        planned: "Planned",
    },
    TimesheetApproval: {
        submit: "Submit timesheet",
        resubmit: "Resubmit",
        approvals: "Approvals",
        pending_title: "Pending approvals",
        none_pending: "Nothing to review",
        approve: "Approve",
        reject: "Reject",
        reason_placeholder: "Reason for rejection",
        confirm: "Confirm",
        cancel: "Cancel",
        status_submitted: "Awaiting approval",
        status_approved: "Approved",
        status_rejected: "Rejected",
    },
    Billable: {
        billable: "Billable",
        non_billable: "Non-billable",
    },
    TimesheetExport: {
        export_csv: "Export CSV",
        exporting: "Exporting…",
    },
    TimesheetInvoice: {
        invoice: "Invoice",
        generating: "Generating…",
        rate: "$/h",
        rate_hint: "Default hourly rate applied to time without a configured rate",
    },
    ProjectWorkplace: {
        msg1: "Project can be shared with members. You can add guests to Folders, Lists, and tasks after creating a Project.",
        msg2: "Currently, there are no plans in place to create private or public projects. If you'd like to initiate a project, upgrading your plan would be necessary.",
    },
    CustomField: {
        custom_field: "Custom Field",
        create_custom_field: "Create Custom Field",
        formula_expression: "Formula",
        formula_expression_placeholder: "e.g. {Estimate} * 2 + {Buffer}",
        referenceable_fields: "Available fields",
        rollup_function: "Aggregate function",
        rollup_source_field: "Source field",
        select_source_field: "Select a field",
        no_numeric_field_found: "No numeric field found",
        lable: "Label",
        action: "Action",
        add_custom_field: "Add Custom Field",
        add_new_custom_field: "Add New Custom Field",
        field_name: "Field Name",
        date_created: "Date Created",
        add_another_item: "Add another item",
        choose_ready_made_list:
            "Choose a ready-made list of option (e.g., days, months, etc.)",
        predefined_options: "Predefined Options",
        selected_by_default: "Selected By Default",
        allow_time_with_date: "Allow users to specify a time with date.",
        date_format: "Date Format",
        days_of_week: "Days of the week",
        past_and_future: "Past & Future",
        select_date_format:
            "Select a date format. D stands for day, M for month, and Y for year.",
        select_dates_past_future:
            "Let users select dates in the past or future",
        select_time_format: "Select a time format",
        time_format: "Time Format",
        unchecking_day_calendar:
            "Unchecking a day will make it unavailable in the calendar",
        future: "Future",
        past: "Past",
        enter_maximum_limit: "Enter Maximum Limit",
        enter_minimum_limit: "Enter Minimum Limit",
        limit_minimum_or_maximum_value:
            "Limit the minimum or maximum value allowed for this field",
        maximum_limit_type_not_allowed_value:
            "The entered value for Maximum Limit Type is not an allowed value.",
        maximum_value_should_be_greater_than_minimum_value:
            "Maximum value should be greater than Minimum value",
        minimum_limit_type_not_allowed_value:
            "The entered value for Minimum Limit Type is not an allowed value.",
        minimum_value_should_not_be_greater_than_maximum_value:
            "Minimum value should not be greater than Maximum value",
        no_country_found: "No country found",
        enter_maximum_limit_type: "Enter Maximum Limit Type",
        enter_minimum_limit_type: "Enter Minimum Limit Type",
        limit_minimum_or_maximum_text_allowed:
            "Limit the minimum or maximum amount of text allowed in this field",
        max_should_be_greater_than_min: "Max should be greater than Min",
        min_should_be_less_than_max: "Min should be less than Max",
        separator: "Separator",
        countryCode: "Turn it on to modify the country code.",
    },
    Category: {
        cateory_name: "Category Name",
        create_category: "Create Category",
        create_channel: "Create Channel",
        edit_category: "Edit Category",
        no_chat_found: "No chats found",
        upgradeplanemsg: "To access this feature please upgrade your plan.",
    },
    Channel: {
        create_channel: "Create Channel",
        msg1: "You reached the maximum public and private channel creation limit. To access this feature please upgrade your plan",
        channel_name: "Channel Name",
        icons: "Icons",
        or: "or",
        only_share_with: "Only Share with",
        private_channel: "Private Channel",
        msg2: "Only selected members and roles will be able to view this channel",
        allowmsg2: "Allows members to send messages in this channel",
        send_messages: "Send Messages",
        choose_to_upload: "Choose an Image to Upload",
        private_channel_limit_reached:
            "You have reached the limit for private channel creation. You can only create public channels. If you want to create a private channel, please upgrade your plan.",
        public_channel_limit_reached:
            "You have reached the limit for public channel creation. You can only create private channels. If you want to create a public channel, please upgrade your plan.",
        edit_channel: "Edit Channel",
        delete_channel: "Delete Channel",
        public_members_hint: "Everyone in the company can see this channel.",
        confirm_delete_channel: "Delete #CHANNEL_NAME?",
        confirm_delete_channel_note: "The channel is removed from the list. Its messages are kept and it can be restored.",
    },
    Templates: {
        delete_template: "Delete Template",
        project_status: "Project Status",
        task_status: "Task Status",
        no_app_selected: "No Apps Selected",
        default_views: "Default Setting for Views",
        apps: "Apps",
        add_new_templete: "Add New Template",
        templates: "Templates",
        s: "s",
        template_name: "Template Name",
        upload_image: "Upload Image",
        all_good: "All good",
        create_template: "Create Template",
        new_template: "New Template",
        remove: "Remove",
        enable_apps: "Enable Apps",
        Turn: "Turn",
        all_apps: "all Apps",
        off: "off",
        on: "on",
        upload: "Upload",
        save_template: "Save Template",
        setup_status: "Set up the statuses for tasks",
        what_task: "What task status do you want",
        select_task_status: "Select Task Status",
        delete_template_confirmation:
            "Are you sure you want to delete the template?",
        ai_sidebar_title: "Create Template With AI",
        ai_label_category: "Category",
        ai_label_description: "Description",
        ai_button_text_requested_changes: "Request Changes",
        ai_min_view_msg_text: "At least one view required",
        ai_min_msg_text: "Minimum 10 characters are required",
        ai_before_desc_placeholder:
            "Enter use case description for generate template",
        ai_after_desc_placeholder:
            "Here you can continue to ask anything for relevant changes",
        try_with_ai: "Try with AI",
        msg_search_result_found:
            "Here are some suggested templates relevant to your requirements. You can select any one or to create using AI, simply click",
        msg_search_result_not_found:
            "No relevant templates found. To create one using AI, simply click",
    },
    Settings: {
        add_new_projects: "Add New Project",
        task_priority: "Task Priority",
        project_skills: "Project Skills",
        project_skills_hint: "Skills that can be assigned to projects to record what a project needs.",
        skill_name_too_short: "The skill name must be at least 2 characters.",
        skill_name_invalid: "Enter a valid skill name.",
        skill_already_exists: "That skill already exists.",
        deactivate_skill: "Deactivate skill",
        deactivate_skill_confirm: "This skill will no longer be available for new projects. Projects already using it keep it.",
        restore: "Restore",
        maximum_image_size: "Maximum image size",
        warning: "Warning",
        cant_delete: "can't delete",
        priority_in_use:
            "The user cannot delete the PRIORITY_NAME priority as it is already in use.",
        company_name: "Company Name",
        phone: "Phone",
        country: "Country",
        state: "State",
        city: "City",
        tracker_estimate_limit: "Limit tracker to estimated hours",
        tracker_estimate_limit_hint: "When on, a task needs estimated hours before the tracker can start and it stops automatically once the estimate is used up. When off, the tracker runs without an estimate limit.",
        select_date_format:"Select Date Format",
        save_changes: "Save Changes",
        two_factor_auth: "Two-Factor Authentication",
        two_factor_desc: "Add an extra layer of security to your account by requiring a code from your authenticator app at sign-in.",
        two_factor_status_enabled: "Two-factor authentication is ON.",
        two_factor_status_disabled: "Two-factor authentication is OFF.",
        two_factor_enable: "Enable",
        two_factor_disable: "Disable",
        two_factor_scan: "Scan this QR code with your authenticator app (Google Authenticator, Authy, 1Password, …).",
        two_factor_manual_key: "Can't scan? Enter this key manually:",
        two_factor_enter_code_enable: "Enter the 6-digit code to confirm",
        two_factor_verify_enable: "Verify & Enable",
        two_factor_recovery_title: "Save your recovery codes",
        two_factor_recovery_desc: "Each code works once. Keep them somewhere safe — you won't see them again. Use one if you lose access to your authenticator app.",
        two_factor_copy: "Copy",
        two_factor_download: "Download",
        two_factor_done: "Done",
        two_factor_disable_label: "Enter a current code or a recovery code to disable",
        two_factor_cancel: "Cancel",
        currencies: "Currencies",
        add_remove_cur: "Add/Remove Currencies",
        change_image: "Change Image",
        Priorities_already_Exists: "Priorities already Exists",
        The_priority_image_field_is_required:
            "The priority image field is required",
        The_priority_name_field_is_required:
            "The priority name field is required",
        The_priority_name_field_must_be_at_least:
            "The priority name field must be at least 3 characters",
        "The file extension field is required":
            "The file extension field is required",
        The_file_extension_field_must_be_at_least:
            "The file extension field must be at least 3 characters",
        file_extension_is_not_supported: "file extension is not supported",
        file_extension_already_Exists: "file extension already Exists",
        The_file_extension_field_is_required:
            "The file extension field is required.",
    },
    Members: {
        invite: "Invite",
        all_members: "All members",
        removed_members: "Removed members",
        name: "Name",
        role: "Role",
        last_active: "Last Active",
        time_tracker: "Time Tracker",
        settings: "Settings",
        removeuser: "Remove User",
        adduser: "Add User",
        invite_user: "Invite User",
        remove_request: "Remove Request",
        resend_invitation: "Resend Invitation",
        cancel_invitation: "Cancel Invitation",
        Invitation_mail_sent_sucessfully: "Invitation mail sent sucessfully",
        confirm_change_user_designation:
            "Are you sure you want to change this user's designation to",
        confirm_change_user_role:
            "Are you sure you want to change this user's role to",
        Import_users_from_csv: "Import users from CSV",
    },
    Upgrades: {
        take_next_step: "Take the next step with your work",
        you_are_on: "You are currently on the",
        per_year: "Per Year",
        per_month: "Per Month",
        current_plane: "Current Plan",
        per_member: "Per Member",
        and_much_more: "and much more",
        upgrade_to: "Upgrade to",
        select_payment_method: "Select Payment Method",
        plan: "Plan",
        plane_upgrade: "Plan upgrade successfully",
        plane_upgrade_msg:
            "Plan Upgrade Successful! Your subscription has been upgraded. Please allow 2 to 3 minutes for the changes to take effect everywhere, ensuring you can fully enjoy the expanded features and improvements!",
        something_wrong: "Something went wrong Please try Again",
        unsucessfull_msg:
            "Plan Upgrade Unsuccessful. We encountered an issue while upgrading your plan. Please try again or contact support for assistance.",
        upgrade_your_plan: "Upgrade Your Plan",
        to_unlock_custom_field: "To Unlock Custom Field",
        unlimited: "Unlimited",
        the_feature_not_available:
            "That feature isn’t available on your current plan",
        unlock_project_permission: "To Unlock Project Permissions",
        unlock_custom_field: "To Unlock Custom Field",
        to_unlock_milestone: "To Unlock Milestone",
        to_unlock_milestone_report: "To Unlock Milestone Report",
        to_unlock_security: "To Unlock Security & Permissions",
        to_unlock_team: "To Unlock Team",
        to_unlcok_project: "To Unlock Project",
        You_have_reached_the_free_plan_limit:
            "You've reached the PLAN_NAME limit",
        require_upgrade_message:
            "You can create up to PROJECT_COUNT projects on the PROJECT_NAME plan. Create more boards by upgrading your plan.",
        are_you_sure_you_want_to_update: "Are you sure you want to update?",
        find_out_whats_included_in_this_update:
            "Find out what’s included in this update",
        improved_performance: "Improved Performance",
        install_now: "Install Now",
        later: "Later",
        please_see_below_for_a_list_of_changes_to_the_features:
            "Please see below for a list of changes to the features.",
        to_integrate_new_services_into_an_alian_hub:
            "To integrate new services into Hyphen OI Pro.",
        whats_new: "What’s new?",
        check_to_agree_with_above_points: "Check to agree with above points",
        general_notes: "General Notes",
        update_now: "Update Now",
        unlock_channel: "To Unlock Channel",
        unlock_chat: "To Unlock Chat",
        unlock_one_chat: "To Unlock One to One Chat",
        public_private_creation_time_limit_reached:
            "You have reached the limit for project creation. If you want to create a project, please upgrade your plan.",
        public_creation_time_limit_reached:
            "You have reached the limit for public project creation. You can only create private projects. If you want to create a public project, please upgrade your plan.",
        private_creation_time_limit_reached:
            "You have reached the limit for private project creation. You can only create public projects. If you want to create a private project, please upgrade your plan.",
    },
    Permissions: {
        advanced_permission: "Advanced Permissions",
        allow_admins: "Allow admins to manage private Spaces",
        when_admin_enable:
            "When enabled, admins will be able to add/remove people and transfer ownership of all Spaces.",
        show_all_projects: "Show all projects",
        when_user_enable:
            "When enabled, users will be able to see all the global projects.",
        show_all_task: "Show all tasks",
        when_user_enable_sprint:
            "When enabled, users will be able to see all the tasks in the sprints.",
        own: "Own",
        select: "Select",
        Member: "Member",
        Guest: "Guest",
        None: "None",
        Read: "Read",
        add_new_team: "Add New Team",
        "Read & Write": "Read & Write",
        Support: "Support",
        select_priorities: "Select Priorities",
        apply_permission: "Apply Permission",
        project_permission_description:
            "To override the global permissions, it is disabled by default. After it is enabled, you can manage project and task permissions. If it is disabled, the global permissions are then applied",
        project_permission_title_disable:
            "The ability to grant custom permissions for this project will be disabled",
        project_permission_title_enable:
            "The ability to grant custom permissions for this project will be enabled",
        reset_permission: "Reset Permission",
    },
    subProjectRulesNames: {
        Project_List: "Project List",
        Project_Create: "Project Create",
        Project_Name_Edit: "Project Name Edit",
        Project_Sprint_Create: "Project Sprint Create",
        Project_folder_Create: "Project folder Create",
        Project_folder_Name_Edit: "Project folder Name Edit",
        Project_sprint_Name_Edit: "Project sprint Name Edit",
        Project_Details: "Project Details",
        Project_Status_Change: "Project Status Change",
        Project_Assignee: "Project Assignee",
        Project_Category: "Project Category",
        Proejct_Source: "Project Source",
        Project_Type: "Project Type",
        Project_Currency: "Project Currency",
        Project_Amount: "Project Amount",
        "Project_Start Date": "Project Start Date",
        "Project_End Date": "Project End Date",
        "Project_Due Date": "Project Due Date",
        Project_Close: "Project Close",
        Project_Description: "Project Description",
        Project_Checklist: "Project Checklist",
        "Project_Checklist_Assign/remove": "Project Checklist Assign/remove",
        Project_Attachments: "Project Attachments",
        Project_Milestone: "Project Milestone",
        Task_list: "Task list",
        Task_Create: "Task Create",
        Sub_Task_Create: "Sub Task Create",
        Task_Name_Edit: "Task Name Edit",
        Task_Status: "Task Status",
        Task_Assignee: "Task Assignee",
        Task_Priority: "Task Priority",
        Task_Due_Date: "Task Due Date",
        Task_Estimated_Hours: "Task Estimated Hours",
        Task_Description: "Task Description",
        Task_Checklist: "Task Checklist",
        "Task_Checklist_Assign/remove": "Task Checklist Assign/remove",
        Task_Attachments: "Task Attachments",
        Show_Tasks: "Show Tasks",
        Custom_Field: "Custom Field",
        Edit_Company: "Edit Company",
        File_Extensions: "File Extensions",
        Project_Milestone_Status: "Project Milestone Status",
        Invite_Member: "Invite Member",
        Member_list: "Member list",
        Create_Team: "Create Team",
        Team_List: "Team List",
        "Security_&_Permissions": "Security & Permissions",
        Role_Management: "Role Management",
        Designation: "Designation",
        Milestone_Weekly_Range: "Milestone Weekly Range",
        User_Timesheet: "User Timesheet",
        Project_Timesheet: "Project Timesheet",
        Workload__Timesheet: "Workload Timesheet",
        Milestone_Report: "Milestone Report",
        Project: "Project",
        Task: "Task",
        Company_Settings: "Company Settings",
        Sheet_Settings: "Sheet Settings",
        Team_Color: "Team Color",
        Team_Name: "Team Names",
        Add_Member: "Add Member",
        Add_New_Designation: "Add New Designation",
    },
    Notification: {
        Notification: "Notification",
        notification_setting: "Notification Settings",
        browser: "Browser",
        mobile: "Mobile",
        before: "Before",
        chat: "Chat",
        project: "Project",
        tasks: "Tasks",
        before_project_due_date: "Project Due Date",
        before_project_end_date: "Project End Date",
        before_task_due_date: "Task Due Date",
        before_task_end_date: "Task End Date",
        message_create: "Message Create",
        project_create: "Project Create",
        project_name: "Project Name",
        project_status_change: "Project Status Change",
        project_assignee: "Project Assignee",
        project_lead: "Project Lead",
        project_category: "Project Category",
        project_source: "Project Source",
        project_type: "Project Type",
        project_currency: "Project Currency",
        project_amount: "Project Amount",
        project_start_date: "Project Start Date",
        project_end_date: "Project End Date",
        project_due_date: "Project Due Date",
        project_close: "Project Close",
        project_description: "Project Description",
        project_checklist: "Project Checklist",
        project_checklist_assign: "Project Checklist Assign",
        project_checklist_remove: "Project Checklist Remove",
        project_attachments: "Project Attachments",
        project_milestone: "Project Milestone",
        project_milestone_status_change: "Project Milestone Status Change",
        project_sprint_create: "Project Sprint Create",
        project_folder_create: "Project Folder Create",
        "comments_im_@mentioned_in": "Comments I'm {'@'}mentioned In",
        task_notification: "Task Notification",
        task_create: "Task Create",
        task_edit: "Task Edit",
        task_status: "Task Status",
        task_assignee: "Task Assignee",
        task_priority: "Task Priority",
        task_type: "Task Type",
        task_due_date: "Task Due Date",
        task_description: "Task Description",
        task_checklist: "Task Checklist",
        task_checklist_assign: "Task Checklist Assign",
        task_checklist_remove: "Task Checklist Remove",
        task_attachments: "Task Attachments",
        "comments_Im_@mentioned_in": "Comments I'm {'@'}mentioned In",
        logged_hours_notification: "Logged Hours Notification",
        after_3_hours_today_pending_hours:
            "After 3 hours Today Pending Hours Log Notification",
        task_estimated_hours: "Task Estimated Hours",
    },
    TimeTracker: {
        TimeTracker: "Time Tracker",
        unlock: "Unlock the Universe with Hyphen OI Pro Tracker on Your Desktop!",
        smooth: "Smoothly track hours spent by users working on projects or tasks with time tracking.",
        click: "click",
        No_Record_Found: "No Record Found",
        total: "Total",
        screenshot_preview: "Screenshot Preview",
        log_time_found_no_screenshot:
            "Log time was found, but no screenshot was captured for this duration.",
    },
    settingslider: {
        "Time Tracking": "Time Tracking",
        Notifications: "Notifications",
        Company: "Company",
        "My Settings": "My Settings",
        "Security & Permissions": "Security & Permissions",
        SSO: "SSO",
        "Audit Log": "Audit Log",
        SCIM: "SCIM",
        "Time Off": "Time Off",
        Upgrade: "Upgrade",
        "Custom Field Manager": "Custom Field Manager",
        Templates: "Templates",
        Projects: "Projects",
        Teams: "Teams",
        Members: "Members",
        Settings: "Settings",
        "Change Password": "Change Password",
        "Two-Factor Authentication": "Two-Factor Authentication",
        "Integrations": "Integrations",
    },
    Sso: {
        title: "Single Sign-On (SSO)",
        subtitle: "Let members sign in through your identity provider (Keycloak, Authentik, Azure AD, Okta…).",
        provider: "Provider",
        enabled: "Enabled",
        disabled: "Disabled",
        discovery_url: "Discovery URL",
        client_id: "Client ID",
        client_secret: "Client secret",
        scopes: "Scopes",
        entry_point: "IdP SSO URL (entry point)",
        entity_id: "IdP entity ID",
        idp_cert: "IdP signing certificate",
        auto_provision: "Auto-provision new users on first login",
        urls_hint: "Give these to your IdP, and share the login URL with your team:",
        login_url: "Login URL",
        redirect_uri: "Redirect URI",
        metadata: "SP metadata",
        saving: "Saving…",
    },
    Scim: {
        title: "SCIM Provisioning",
        subtitle: "Let your identity provider create, update, and deactivate members automatically (Okta, Azure AD, OneLogin…).",
        enabled: "Enabled",
        disabled: "Disabled",
        default_role: "Default role for provisioned users",
        default_role_hint: "New users created by your IdP get this role.",
        role_admin: "Admin",
        role_member: "Member",
        role_guest: "Guest",
        connect_hint: "Configure these in your IdP's SCIM / provisioning settings:",
        base_url: "SCIM base URL",
        token_label: "Bearer token",
        token_hidden: "hidden for security",
        no_token: "Not generated yet",
        token_once: "Copy this token now — it will not be shown again.",
        copy: "Copy",
        copied: "Copied!",
        generate: "Generate token",
        rotate: "Regenerate token",
        working: "Working…",
    },
    Audit: {
        title: "Audit Log",
        subtitle: "An immutable record of sensitive actions in this workspace — role changes, SSO updates, and more.",
        refresh: "Refresh",
        loading: "Loading…",
        f_action: "Action",
        f_action_ph: "e.g. member.update",
        f_entity: "Entity type",
        f_from: "From",
        f_to: "To",
        apply: "Apply",
        clear: "Clear",
        col_time: "Time",
        col_actor: "Actor",
        col_action: "Action",
        col_entity: "Entity",
        col_ip: "IP",
        col_details: "Details",
        empty: "No audit events match these filters.",
        showing: "Showing {from}–{to} of {total}",
        prev: "Prev",
        next: "Next",
    },
    Offline: {
        offline_msg: "You're offline — changes are saved and will sync when you reconnect.",
        syncing: "Syncing {n} change(s)…",
        pending: "{n} change(s) waiting to sync",
    },
    Pto: {
        add_title: "Request time off",
        type: "Type",
        types: { casual: "Casual Leave", privilege: "Privilege Leave", sick: "Sick Leave", vacation: "Vacation", holiday: "Holiday", personal: "Personal", unpaid: "Unpaid" },
        start: "Start date",
        end: "End date",
        hours_per_day: "Hours per day",
        duration: "Duration",
        full_day: "Full day",
        half_day: "Half day",
        custom_hours: "Custom hours",
        reason: "Reason",
        reason_ph: "Optional note",
        request: "Request",
        saving: "Saving…",
        requested: "Time off requested.",
        dates_required: "Start and end dates are required.",
        date_order: "End date must be on or after the start date.",
        failed: "Could not save.",
        capacity_title: "My capacity this month",
        cap_total: "Working hours",
        cap_pto: "Time off",
        cap_avail: "Available",
        team_title: "Team time off",
        my_title: "My time off",
        refresh: "Refresh",
        search_member: "Search member…",
        all_status: "All statuses",
        all_types: "All types",
        prev: "Prev",
        next: "Next",
        page: "Page",
        col_created: "Created",
        col_dates: "Dates",
        col_member: "Member",
        col_type: "Type",
        col_hours: "Hours",
        col_status: "Status",
        col_reason: "Reason",
        col_days: "Total Days",
        total_days: "Total days",
        working_days: "working days",
        status: { pending: "Pending", approved: "Approved", rejected: "Rejected" },
        approve: "Approve",
        reject: "Reject",
        delete: "Delete",
        delete_locked: "An approved leave can't be deleted",
        empty: "No time-off entries.",
        loading: "Loading…",
    },
    Inbox: {
        title: "Inbox",
        tab_all: "All",
        tab_notifications: "Notifications",
        tab_mentions: "Mentions",
        tab_archive: "Archive",
        tab_hint_all: "Everything unread, notifications and mentions together.",
        tab_hint_notifications: "Unread notifications.",
        tab_hint_mentions: "Where someone mentioned you.",
        tab_hint_archive: "Everything you have already read.",
        source_all: "All",
        source_notifications: "Notifications",
        source_mentions: "Mentions",
        customize: "Customize Inbox",
        opt_showAllTab: "Show All tab",
        opt_groupByDate: "Group by date",
        opt_newestFirst: "Sort by newest first",
        mark_all_read: "Mark all as read",
        mark_read: "Mark as read",
        mark_unread: "Mark as unread",
        no_task: "General",
        today: "Today",
        yesterday: "Yesterday",
        loading: "Loading…",
        retry: "Try again",
        load_more: "Load more",
        load_failed: "Could not load your inbox.",
        action_failed: "That didn't go through.",
        all_read_toast: "All marked as read.",
        zero: "You're all caught up",
        zero_archive: "Nothing read yet",
        zero_sub: "Nothing here needs you right now.",
    },
    Integrations: {
        title: "Integrations",
        desc: "Send task events to Slack, Discord, or any HTTPS endpoint via outgoing webhooks.",
        copied: "Copied to clipboard",
        // AHE-3838 — cloud storage for attachments
        cloud_title: "Cloud storage for attachments",
        cloud_desc: "Optional, and entirely your own. Attach files straight from Google Drive or Dropbox instead of uploading them. Your credentials and your connected account are private to you — nobody else in the workspace can see or change them, and two people can link the same drive account independently. Nobody has to set this up: uploading from your computer works exactly as before.",
        cloud_redirect_uri: "Redirect URI",
        cloud_redirect_hint: "Needed by Google Drive only. Paste this exact value into the provider's console as an authorised redirect URI. It differs per environment, so add the staging and production ones too. Dropbox does not use one.",
        cloud_show_steps: "Setup steps ({count})",
        cloud_hide_steps: "Hide setup steps",
        cloud_ready: "Ready",
        cloud_not_setup: "Not set up for you",
        cloud_setup: "Set up",
        cloud_connect: "Connect my account",
        cloud_disconnect: "Disconnect my account",
        cloud_connected: "Connected",
        cloud_not_connected: "You have not connected your account yet.",
        cloud_your_account: "Your account",
        cloud_reauth: "Your access expired — connect again.",
        cloud_no_signin_needed: "Ready to use. No sign-in needed — you choose files inside the provider's own picker.",
        cloud_secret_set: "•••••••• (leave blank to keep)",
        cloud_saved: "Your {provider} credentials were saved",
        cloud_removed: "Your {provider} credentials were removed",
        cloud_confirm_remove: "Remove your {provider} credentials? This disconnects your {provider} account. Nobody else is affected.",
        cloud_disconnected: "Disconnected from {provider}",
        cloud_connected_toast: "Account connected",
        secret_title: "Save your signing secret",
        secret_desc: "Use it to verify the X-AlianHub-Signature header. It is shown only once.",
        copy: "Copy",
        done: "Done",
        add_webhook: "Add a webhook",
        edit_webhook: "Edit webhook",
        destination: "Destination",
        name: "Name",
        name_ph: "e.g. Team Slack channel",
        url: "Payload URL",
        slack_url: "Slack Incoming Webhook URL",
        discord_url: "Discord Webhook URL",
        slack_hint: "In Slack: Apps → Incoming Webhooks → Add to a channel → copy the webhook URL.",
        discord_hint: "In Discord: Channel → Edit → Integrations → Webhooks → New Webhook → copy the URL.",
        events: "Events",
        all_events: "All task events",
        ev_created: "Task created",
        ev_updated: "Task updated",
        ev_deleted: "Task deleted",
        ev_archived: "Task archived",
        ev_restored: "Task restored",
        send_to_slack: "Send to Slack",
        create: "Create webhook",
        save: "Save changes",
        cancel: "Cancel",
        your_webhooks: "Your webhooks",
        empty: "No webhooks yet. Add one above to start sending task events.",
        active: "Active — events are delivered",
        paused: "Paused — no events delivered",
        logs: "Logs",
        edit: "Edit",
        delete: "Delete",
        no_logs: "No deliveries recorded yet.",
        load_more: "Load more",
        loading: "Loading…",
        event: "Event",
        status: "Status",
        duration: "Duration",
        when: "When",
        retry: "retry",
        last: "Last",
        no_deliveries: "No deliveries yet",
        err_name: "A name is required.",
        err_url: "A valid http(s) URL is required.",
        err_events: "Select at least one event.",
        confirm_delete: "Delete this webhook? Its delivery history will also be removed.",
        secret_copied: "Signing secret copied to clipboard.",
    },
    Chat: {
        welcome_message: "Welcome to BRAND_NAME",
        msg2: "This is a brand-new Group. Here are some steps to help you get started. For more, check out our Getting Started guide",
        chats: "Chats",
        favorites: "Favorites",
        CHANNELS: "CHANNELS",
    },
    Comments: {
        unread_message: "Unread messages",
        more: "more",
        less: "less",
        edited: "edited",
        edit: "Edit",
        create_task: "Create Task",
        add_to_checklist: "Add to Checklist",
        copy_message: "Copy Message",
        reply: "Reply",
        message: "Message",
        mark_unread: "Mark as Unread",
        This_message_is_deleted: "This message is deleted",
        You_deleted_this_message: "You deleted this message",
        no_user_found: "No User Found",
        unlock_comment_view: "To Unlock Comment View",
    },
    PlaceHolder: {
        enter_task_type: "Enter Task Type",
        enter_task_status: "Enter Task Status",
        enter_project_status: "Enter Project Status",
        Enter_Project_Name: "Enter Project Name",
        Enter_Key_Name: "Enter Key Name",
        Enter_Proposal_Id: "Enter Proposal ID",
        Select_Category: "Select Category",
        Select_Project_Due_Date: "Select Project Due Date",
        search: "Search",
        search_here: "Search Here",
        Type_here: "Type here",
        Task_name: "Task name",
        Add_description: "Add description",
        Enter_Duplicate_Task_Name: "Enter Duplicate Task Name",
        Enter_Text: "Enter Text",
        Enter_Amount: "Enter Amount",
        Select: "Select",
        Enter_Refund_Amount: "Enter Refund Amount",
        Enter_Milestone_Name: "Enter Milestone Name",
        Enter_sprint_name: "Enter sprint name",
        Enter_directory_name: "Enter directory name",
        Rename_Tag: "Rename Tag",
        Enter_Team_Name: "Enter Team Name",
        Duration_only_hours: "Duration only hours",
        Enter_option: "Enter option",
        Enter_View_Name: "Enter View Name",
        Enter_URL: "Enter URL",
        Enter_HTML: "Enter HTML",
        Enter_item_name: "+ Enter item name",
        Add_an_item: "+ Add an item",
        Enter_Company_Name: "Enter Company Name",
        Select_Country: "Select Country",
        Enter_Template: "Enter Template",
        Enter_Template_Name: "Enter Template Name",
        Project_key_must_be_unique: "Project key must be unique",
        Enter_zip: "Enter Zip",
        Enter_GST_Number: "Enter GST Number",
        Enter_Milestone_Status: "Enter Milestone Status",
        Enter_Priority_Name: "Enter Priority Name",
        Enter_File_Extensions_Name: "Enter File Extensions Name",
        Enter_Skill_Name: "Enter Skill Name",
        Select_Skills: "Select skills",
        Enter_Task_Name: "Enter Task Name",
        Select_State: "Select State",
        No_States: "No States",
        Select_City: "Select City",
        No_Cities: "No Cities",
        enter_category_name: "Enter Category Name",
        enter_channel_name: "Enter Channel Name",
        Pinned_messages: "Pinned Messages",
        Search: "Search",
        Search_by_name_or_email: "Search by name or email",
        Invite_by_email: "Invite by email",
        Select_Designation: "Select Designation",
        Select_Role: "Select Role",
        Enter_designation: "Enter Designation",
        Enter_Description: "Enter Description",
        Add_New_Role: "Add New Role",
        Enter_role: "Enter role",
        Enter_Field_Label: "Enter Field Label",
        Enter_Placeholder: "Enter Placeholder",
        field_label: "Field Label",
        placeholder: "Placeholder",
        Enter_Number: "Enter Number",
    },
    DuplicateTask: {
        duplicate_task_name: "Duplicate Task Name",
        what_do_you_copy: "What do you want to copy",
        everything: "Everything",
        no_assignee: "No Assignee",
        no_watcher: "No Watcher",
        move_task: "Move Task",
        mearge_task_into: "Merge Task Into",
    },
    Converttolist: {
        are_you_sure_convert:
            "Are you sure want to convert this task into a List?",
        important: "Important",
        you_will_lose:
            "You will lose all threaded comments. This action cant be undone",
        convert_to_list: "Convert to list",
    },
    Billing: {
        billing_details: "Billing Details",
        plan_details: "Plan Details",
        next_msg: "The Next Payable Amount is",
        due_on: "Due on",
        upgrade_plan: "Upgrade Plan",
        cancel_subscription: "Cancel Subscription",
        reactivate_subscription: "Reactivate Subscription",
        biling_info: "Billing Info",
        update_billing_info: "Update Billing Info",
        contact_support: "Contact Support",
        for_help_msg:
            "For help and support with your billing questions, contact our support team and they'll be happy to help.",
        payment_methods: "Payment Methods",
        update_payment_method: "Update Payment Method",
        add_payment_method: "Add Payment Method",
        ending_in: "ending in",
        payment_method_update: "Payment method update succesfully.",
        waiting_msg:
            "Your recent payment method update will take effect with your next bill and will be used for all future payments..",
        error_updating:
            "Payment method update Unsuccessful. We encountered an issue while updating your payment method. Please try again or contact support for assistance.",
        card_expires: "Card expires at",
        billing_address: "Billing Address",
        subscription_plan: "Subscription Plan",
        next_renew_date: "Next Renew Date",
        storage_use: "Storage Use",
        address: "Address",
        address_line: "Address Line",
        zip_code: "Zip Code",
        zip: "Zip",
        "Save_&_Continue": "Save & Continue",
        billing_history: "billing_history",
        Invoices: "Invoices",
        credit_notes: "Credit Notes",
        download: "Download",
        id: "Id",
        type: "Type",
        date: "Date",
        description: "Description",
        no_of_users: "No. of Users",
        amount: "Amount",
        status: "Status",
        pay_now: "Pay Now",
        cancelling_subscription_message:
            "Cancelling subscription means your subscription ends on",
        reactivate_anytime: "Reactivate anytime before then!",
        reactivate_confirmation:
            "Are you sure you want to reactivate subscription? By selecting 'Yes,' you will reactivate and resume your billing schedule.",
        amounting_to: "amounting to",
        insufficient_funds: "Insufficient Funds",
        payment_successful: "Payment successful.",
        payment_successful_details:
            "Payment Successful! Your invoice is paid. Please allow 2 to 3 minutes for the changes to take effect everywhere, ensuring you can fully enjoy the expanded features and improvements!",
        payment_unsuccessful:
            "Payment Unsuccessful. We encountered an issue while upgrading your plan. Please try again or contact support for assistance.",
        plan_upgrade_unsuccessful:
            "Plan Upgrade Unsuccessful. We encountered an issue while upgrading your plan. Please make sure the card has sufficient balance.",
        proceed_with_payment:
            "Do you want to proceed with the payment for invoice number",
        attention_needed: "We need your attention!",
        avoid_service_disruption: "to avoid service disruption",
        subscription_renewal_failed: "Subscription auto-renewal failed due to",
        update_payment_method_please: "Please update your payment method",
        click_here_for_update_payment_method:
            "Click Here for Update Payment Method",
        credit_balance: "Credit Balance",
        this_balance_will_be_used_for_a_future_payment:
            "This balance will be used for a future payment.",
        paymnet_failed_subscription_canceled:
            "We wanted to inform you that your previous subscription has been canceled. Your account has now been transitioned to our default subscription, which has some features disabled. To enable these features, please upgrade your plan.",
        promotional_credit_balance: "Promotional Credit",
        balance: "Balance",
        created_on: "Created On",
        no_promotional_found: "No Promotional Credit History Found",
    },
    Tour: {
        tour_completed: "Tour Completed",
        do_you_have_any:
            "Do you have any queries? We encourage you to explore our comprehensive video tutorials of BRAND_NAME to get started and make the most of your experience.",
        watch_video: "Watch Video",
        have_brief_tour_alianhub: "Have a brief tour of BRAND_NAME?",
        have_brief_tour_alianhub_view: "Have a brief tour of BRAND_NAME views?",
        have_brief_tour_alianhub_left_side:
            "Have a brief tour of Project listing?",
        look_how_to_create:
            "Look how to create project, manage tasks, view Time Sheet reports, enter a chat, view mentions and notifications, and more.",
        lets_start: "Let’s Start",
        no_thanks: "No Thanks",
        have_brief_task: "Have a brief tour of Task?",
        have_brief_tour_project: "Have a brief tour of project?",
        look_how_to_create_task:
            "Look how to create Task, manage Task , view task according to status group and more.",
        look_how_to_create_project:
            "Look how to create Project, manage Project , view task according to status group and more.",
        project_creation_description:
            "Projects can be effortlessly created, assigned, and tracked, with clear visibility of responsibilities for team members. This promotes better organization, leading to enhanced efficiency and productivity. Click here to start a new project.",
        enter_project_name: "Please enter a brief name for your project.",
        enter_project_key: "Please enter a brief key for your project.",
        add_project_category: "Please add a category for your project.",
        enter_project_duedate: "Please enter a due date for your project.",
        add_project_lead_assignee: "Please add lead assignee for your project.",
        create_project_from_template:
            "This option enables you to quickly create a new project using an existing template, which comes with preconfigured data and settings, allowing you to replicate the same project setup easily.",
        customize_project_section:
            "This option allows you to fully personalize your project by setting up various elements like statuses, types, apps, and more, tailored to meet your specific needs.",
        task_type_templates_list_text: "Task Type Templates List",
        task_type_templates_description_text:
            "This section displays available task type templates. Select the one that suits your needs.",
        create_new_task_type_template_text: "Create New Task Type Template",
        create_new_task_type_template_description_text:
            "Click the + button to add a new task type template, which you can then use for your tasks.",
        view_template_task_types_text: "View Template Task Types",
        view_template_task_types_description_text:
            "Here you can see the task types linked to the selected template. You can modify or add new task types based on your needs.",
        add_new_task_type_text: "Add New Task Type",
        add_new_task_type_description_text:
            "Click on the 'Add Task Type' button to include new task types into the selected template.",
        save_project_as_template_text: "Save Project as Template",
        save_project_as_template_description_text:
            "Click 'Save as Template' to store the current setup for use in future projects.",
        initiate_new_project_text: "Initiate New Project",
        initiate_new_project_description_text:
            "Click here to start a new project.",
        add_new_task_text: "Add New Task",
        input_task_name_text: "Input Task Name",
        choose_task_status_text: "Choose Task Status",
        assign_task_text: "Assign Task",
        set_task_deadline_text: "Set Task Deadline",
        define_task_priority_text: "Define Task Priority",
        view_task_list_text: "View Task List",
        task_information_text: "Task Information",
        quick_task_menu_text: "Quick Task Menu",
        task_actions_text: "Task Actions",
        subtask_toggle_text: "Subtask Toggle",
        task_tour_complete_text: "Task Tour Complete",
        create_new_task_description_text:
            "Create a new task by clicking on the '+ New Task' button.",
        input_task_name_description_text:
            "Enter the name of the task in the provided input field.",
        choose_task_status_description_text:
            "Select the appropriate task type according to your needs.",
        assign_task_description_text:
            "Select the person to whom the task will be assigned.",
        set_task_deadline_description_text: "Pick a due date for the task.",
        define_task_priority_description_text:
            "Choose the priority level for the task.",
        view_task_list_description_text:
            "This is a list of tasks, displaying their details and grouped by status.",
        task_information_description_text:
            "Here are the details for the selected task.",
        quick_task_menu_description_text:
            "Clicking the icon will open a dropdown menu with task operation options.",
        task_actions_description_text:
            "Select an action from the list of available task operations.",
        subtask_toggle_description_text:
            "Here is a toggle to display the list of subtasks.",
        task_tour_complete_description_text:
            "The tour has concluded. Start exploring the many possibilities ahead!",
        search_and_filter_projects_text: "Search and Filter Projects",
        search_projects_text: "Search Projects",
        search_options_for_projects_text: "Search Options for Projects",
        search_projects_by_name_text: "Search Projects by Name",
        advanced_project_search_text: "Advanced Project Search",
        filter_projects_by_favorites_text: "Filter Projects by Favorites",
        project_settings_text: "Project Settings",
        project_list_text: "Project List",
        end_of_project_view_tour_text: "End of Project View Tour",
        search_and_filter_projects_description_text:
            "Search and filter projects based on your criteria here.",
        enter_search_keywords_text:
            "Enter search keywords to find specific projects.",
        search_filter_dropdown_description_text:
            "Click the icon to open a dropdown menu with search filters.",
        toggle_search_options_description_text:
            "Toggle between options to search by project, sprint, or folder as you type.",
        advanced_search_icon_description_text:
            "Click the icon to perform an advanced search operation.",
        filter_by_favorites_description_text:
            "Click the star icon to prioritize your favorite projects at the top of the list.",
        project_settings_icon_description_text:
            "Click the settings icon to switch between archived or unarchived project options.",
        view_project_list_description_text:
            "Here, you can view your list of projects.",
        end_of_project_view_tour_description_text: "Tour is now complete.",
        create_assign_prioritize_monitor_projects_text:
            "Easily create, assign, prioritize, and monitor projects. Team members can clearly view their tasks, stay organized, and enhance efficiency and productivity. Click here to initiate a New Project.",
        track_users_time_sheet_reports_text:
            "Effectively track users' time with various Time Sheet Reports such as User Time Sheet, Project Time Sheet, Workload Time Sheet, and Tracker Timesheet. Click here to explore the Time Sheet Reports.",
        user_time_sheet_description_text:
            "The user time sheet allows you to monitor the hours logged by each user according to your user role.",
        project_time_sheet_description_text:
            "Track the hours logged for each project in the project time sheet based on your user role.",
        workload_time_sheet_description_text:
            "Similar to the User time sheet, the workload time sheet also includes details about the user's workload, total hours, and estimated hours.",
        tracker_sheet_description_text:
            "The tracker sheet shows time logged via the time tracker, along with screenshots and the total tracked time.",
        view_companies_switch_text:
            "See all the companies you're associated with and effortlessly switch between them by selecting one.",
        engage_team_real_time_text:
            "Engage with team members in real-time for quick decision-making. Create channels and share information via attachments, voice messages, and text.",
        real_time_notifications_text:
            "Stay updated with real-time notifications about project and task activities, including task assignments, status changes, comments, and deadlines.",
        address_specific_individuals_text:
            "Directly address specific individuals within the project management system. View mentions related to tasks, projects, or discussions.",
        access_personal_information_text:
            "Access your personal information, along with settings related to companies, projects, users, and security, based on your user role.",
        project_views_list_text: "Project Views List",
        add_new_project_view_text: "Add New Project View",
        manage_project_views_text: "Manage Project Views",
        project_files_text: "Project Files",
        project_audio_files_text: "Project Audio Files",
        add_project_watcher_text: "Add Project Watcher",
        project_operation_list_text: "Project Operation List",
        advanced_task_filter_text: "Advanced Task Filter",
        search_tasks_text: "Search Tasks",
        search_options_menu_text: "Search Options Menu",
        search_criteria_text: "Search Criteria",
        project_views_list_description_text:
            "A list of available project views.",
        add_new_project_view_description_text: "Create a new view here.",
        manage_project_views_description_text:
            "This is where you can add or pin views to a project. Click 'Add View' to add, or select 'Pin View' to pin a view.",
        project_files_description_text:
            "Access all project files and links by clicking the icon.",
        project_audio_files_description_text:
            "Click the icon to view all audio files related to the project.",
        add_project_watcher_description_text:
            "Manage your project watcher settings.",
        project_operation_list_description_text:
            "Perform various project operations from here.",
        advanced_task_filter_description_text:
            "Click the icon to perform an advanced search operation.",
        search_tasks_description_text:
            "Enter relevant keywords to search for specific tasks.",
        search_options_menu_description_text:
            "Click the icon to open a dropdown with different search options.",
        search_criteria_description_text:
            "Choose between task name, task key, or description to refine your search as you type.",
        select_operation_description_text:
            "Select an operation from the list to perform the desired action on the project.",
    },
    TaskStatus: {
        To_Do: "To Do",
    },
    AI: {
        generate: "Generate",
        ai_button: "Write with AI",
        ai_title: "Ask AI to find or create anything",
        write_with_ai: "Write with AI",
        suggest_tasks: "Suggest Tasks",
        suggest_subtasks: "Suggest Subtasks",
        ai_sidebar_placeholder: "What would you like AI to write about?",
        ai_chat_placeholder: "Tell AI What to do next",
        ai_available_on_paid_plans_upgrade_now:
            "AI is only available for purchase on our paid plans. Upgrade and add AI now!",
        please_upgrade_plan_to_use_ai: "Please upgrade your plan to use AI.",
        read_less: "Read Less",
        read_more: "Read More",
        to_unlock_ai: "To Unlock AI",
        copy: "Copy",
        generating_results: "Generating Results",
        hub_ai: "HubAi",
        regenerate: "Regenerate",
        title: "Title",
        error_occurred_engine_issue:
            "An error occurred. Either the engine you requested does not exist or there was another issue processing your request",
        ai_not_integrated: "AI is not integrated in your system",
        limit_reached: "You have reached your limit",
        ai_write_description: "Write with AI",
        ai_desc_intent_placeholder: "What should this description cover? (optional)",
        ai_desc_intent_hint: "Leave blank to generate from the title.",
        ai_desc_mode_add: "Add to description",
        ai_desc_mode_rewrite: "Rewrite",
        ai_desc_add_placeholder: "What should I add — and where? (e.g. add acceptance criteria, or a note under What to do)",
        ai_desc_add_hint: "AI places your addition where you ask, keeps everything else, and shows the full result to review before applying.",
        ai_generate: "Generate",
        ai_regenerate: "Regenerate",
        ai_use_this: "Use this",
        ai_answer_questions: "Answer a couple of quick questions so the description is accurate:",
        ai_generating: "Generating…",
        ai_failed: "Couldn't generate a description. Please try again.",
        ai_optional: "— optional",
        ai_skills_hint: "Skills this project needs. The AI also suggests skills from your description — you can adjust them on the review step.",
        ai_proposal_id_hint: "The won proposal this project came from. Used to tie the project back to the bid it originated from.",
    },
    ScreenshotRetention: {
        heading: "Auto-delete old screenshots",
        subtitle: "When enabled, time-tracker screenshots older than the retention window are permanently deleted every night.",
        toggle_label: "Enable auto-deletion",
        toggle_hint: "Existing screenshots older than the window are removed on the next nightly run.",
        window_label: "Retention window",
        window_hint: "How long screenshots are kept before they're eligible for deletion.",
        months_option: "{n} months",
        confirm_title: "Permanently delete old screenshots?",
        confirm_body: "Enabling this will delete approximately <b>{count}</b> screenshots older than {months} months on the next nightly run. This cannot be undone.",
        confirm_yes: "Enable and delete",
        saved: "Screenshot retention saved",
        save_failed: "Could not save retention settings",
        last_run: "Last run {when} — deleted {deleted} screenshots.",
        not_run_yet: "First cleanup runs tonight at 00:30 UTC.",
        today: "today",
        yesterday: "yesterday",
        days_ago: "{n} days ago",
        months_ago: "{n} months ago",
    },
    TimeReminder: {
        heading: "Daily \"log your time\" reminder",
        subtitle: "When enabled, Hyphen OI Pro emails a daily reminder to the selected members who haven't logged time that day.",
        toggle_label: "Enable daily reminder",
        toggle_hint: "Off by default. Turn on to send the reminder for this company.",
        recipients_label: "Send to",
        recipients_hint: "Only the selected members receive the reminder. If none are selected, no email is sent.",
        select_all: "Select all",
        search_placeholder: "Search members by name or email",
        no_members: "No members with an email address were found.",
        no_results: "No members match your search.",
        selected_count: "{n} selected",
        save: "Save recipients",
        saved: "Reminder settings saved",
        save_failed: "Could not save reminder settings",
        recipients_saved: "Recipients updated",
        enabled_toast: "Daily reminder enabled",
        disabled_toast: "Daily reminder disabled",
    },
    Toast: {
        Skill_added_successfully: "Skill added successfully",
        Skill_deactivated_successfully: "Skill deactivated successfully",
        Skill_restored_successfully: "Skill restored successfully",
        Your_card_is_expired: "Your card is expired.",
        Password_set_new_has_been_successfully:
            "New password set has been successfully",
        task_created_successfully: "Task Created Succeessfully",
        please_remove_the_advanced_filter_to_view_newly_created_projects:
            ", Please remove the advanced filter to view newly created projects.",
        create_task_plan_limit_message:
            "Upgrade your plan. You have reached the limit for creating tasks in the TASK_SPRINT sprint.",
        something_went_wrong: "Something went wrong.",
        file_size_is_larger_than_maxFileSize:
            "file size is larger than maxFileSize",
        Select_image_only_and_image_file_format_should_be_FILE_FORMATS:
            "Select image only and image file format should be FILE_FORMATS",
        image_dimensions_exceed_limit:
            "Image dimensions should not exceed MAX_WIDTHxMAX_HEIGHT px",
        Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS:
            "Select file only image and image file format should be FILE_FORMATS",
        Multiple_files_not_allowed: "Multiple files not allowed.",
        Please_select_valid_file: "Please select valid file.",
        require_image_format_message:
            "File format is not supported or not added in Company settings, you can add file format in Settings.",
        You_have_to_add_extension_in_setting:
            "You have to add extension in setting.",
        Something_went_wrong_Please_try_again:
            "Something went wrong. Please try again.",
        Company_is_disable: "Company is disable",
        advance_search_feature_upgrade_message:
            "That feature Advance Search isn’t available on your current plan.To Unlock Advance Search Upgrade Your Plan.",
        Access_Denied: "Access Denied",
        notification_permission:
            "To receive notifications, please allow Notification permission in site settings and reload page again.",
        Link_is_Copied_to_clipboard: "Link is Copied to clipboard",
        Task_Key_is_Copied_to_clipboard: "Task Key is Copied to clipboard",
        At_least_one_field_is_required: "At least one field is required.",
        Task_name_updated_successfully: "Task name updated successfully",
        Watcher_added_successfully: "Watcher added successfully",
        Watcher_removed_successfully: "Watcher removed successfully",
        Nothing_to_update: "Nothing to update",
        "Sprint created successfully": "Sprint created successfully",
        "Sprint restored successfully": "Sprint restored successfully",
        "Sprint closed successfully": "Sprint closed successfully",
        "Sprint archived successfully": "Sprint archived successfully",
        "Sprint deleted successfully": "Sprint deleted successfully",
        Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints:
            "Upgrade your plan. You have reached the limit for creating sprints.",
        "Folder created successfully": "Folder created successfully",
        "Folder updated successfully": "Folder updated successfully",
        "Folde restored successfully": "Folder restored successfully",
        "Folder closed successfully": "Folder closed successfully",
        "Folder archived successfully": "Folder archived successfully",
        "Folder deleted successfully": "Folder deleted successfully",
        Status_changed_successfully: "Status changed successfully",
        Due_date_updated_successfully: "Due date updated successfully",
        Due_date_not_updated: "Due date not updated",
        "Assignee changed_ uccessfully": "Assignee changed successfully",
        "Assignee added successfully": "Assignee added successfully",
        "Assignee removed successfully": "Assignee removed successfully",
        "Assignee not updated": "Assignee not updated",
        Created_by_updated_successfully: "Created by updated successfully",
        Created_by_not_updated: "Created by not updated",
        Task_updated_successfully: "Task updated successfully",
        Task_restored_successfully: "Task restored successfully",
        Task_archived_successfully: "Task archived successfully",
        Task_deleted_successfully: "Task deleted successfully",
        Tag_Deleted_successfully: "Tag Deleted successfully",
        Log_time_added_successfully: "Log time added successfully..",
        Filter_saved_successfully: "Filter saved successfully.",
        Filter_update_successfully: "Filter updated successfully.",
        Filter_deleted_successfully: "Filter deleted successfully.",
        "Checklist_creted_succesfully.": "Checklist creted succesfully.",
        Please_select_checklist: "Please select checklist.",
        already_exists: "EXIST_VALUE is already exists",
        Converted_sucessfully: "Converted sucessfully",
        create_task_limit_in_sprint_upgrade_task_message:
            "Upgrade your plan. You have reached the limit for creating tasks in the SELECTED_SPRINT_DATA sprint.",
        Please_Select_Task_Type: "Please Select Task Type",
        Please_Select_Task: "Please Select Task",
        Task_moved_sucessfully: "Task moved sucessfully",
        Task_not_moved: "Task not moved",
        Task_duplicate_sucessfully: "Task duplicate sucessfully",
        Task_not_duplicated: "Task not duplicated",
        Convert_in_to_task_sucessfully: "Convert in to task sucessfully",
        Company_name_already_exists: "Company name already exists",
        Company_has_been_created_Successfully:
            "Company has been created Successfully.",
        Custom_field_updated_successfully: "Custom field updated successfully",
        No_assignee_found: "No assignee found",
        No_due_date_found: "No due date found",
        No_self_assignee_found: "No self assignee found",
        Estimated_time_updated_successfully:
            "Task Planning updated successfully",
        Description_updated_successfully: "Description updated successfully",
        Description_not_updated: "Description not updated",
        Copied: "Copied!",
        User_removed_successfully: "User removed successfully",
        Invitation_cancelled_successfully: "Invitation cancelled successfully",
        User_role_changed_successfully: "User role changed successfully",
        User_designation_changed_successfully:
            "User designation changed successfully.",
        Please_upgrade_your_plan_to_use_Time_Tracker:
            "Please upgrade your plan to use Time Tracker.",
        Request_remove_successfully: "Request remove successfully",
        Upgrade_Your_Plan: "Upgrade Your Plan",
        Updated_successfully: "Updated successfully",
        Deleted_successfully: "Deleted successfully",
        View_Pinned: "View Pinned",
        View_Unpinned: "View Unpinned",
        View_Already_Added: "View Already Added",
        Company_details_saved_successfully:
            "Company details saved successfully.",
        Currency_added_successfully: "Currency added successfully",
        Currency_removed_successfully: "Currency removed successfully",
        File_extension_remove_successfully:
            "File extension FILE_EXTENSION remove successfully",
        File_extension_update_successfully:
            "File extension update successfully.",
        Status_updated_successfully: "Status updated successfully",
        Project_milestone_status_Deleted_successfully:
            "Project milestone status deleted successfully.",
        Milestone_weekly_range_updated_successfully:
            "Milestone weekly range updated successfully.",
        Image_dimensions_should_not_exceed_ImageDimensions_pixels:
            "Image dimensions should not exceed ImageDimensions pixels.",
        error_in_uploading_image_please_try_it_again:
            "error in uploading image please try it again",
        Task_priority_updated_successfully:
            "Task priority updated successfully.",
        Task_priority_Remove_successfully: "Task priority Remove successfully.",
        Priority_updated_successfully: "Priority updated successfully",
        Priority_not_updated: "Priority not updated",
        error_in_deleting_priority_please_try_it_again:
            "error in deleting priority please try it again",
        Field_Enable_Successfully: "Field Enable Successfully",
        Field_Disable_Successfully: "Field Disable Successfully",
        Field_Added_Successfully: "Field Added Successfully",
        Field_Updated_Successfully: "Field Updated Successfully",
        Added_to_favourite: "Added to favourite",
        Removed_from_favourite: "Removed from favourite",
        Tag_Created_successfully: "Tag Created successfully",
        "Queue list added successfully": "Queue list added successfully",
        "Queue list removed successfully": "Queue list removed successfully",
        "Queue list not updated": "Queue list not updated",
        Attachments_uploaded_successfully: "Attachments uploaded successfully",
        Attachment_removed_successfully: "Attachment removed successfully",
        Attachment_not_removed: "Attachment not removed",
        Please_try_again: "Please try again",
        Task_name_copied: "Task name copied",
        Status_already_exists: "Status already exists",
        Status_added_sucessfully: "Status added sucessfully",
        Task_Type_already_exists: "Task Type already exists",
        Task_Type_added_sucessfully: "Task Type added sucessfully",
        Image_size_must_be_less_than_ImageDimensions_pixels:
            "Image size must be less than ImageDimensions pixels.",
        Data_deleted_successfully: "Data deleted successfully.",
        Category_created_successfully: "Category created successfully",
        Category_updated_successfully: "Category updated successfully",
        Please_select_an_image_file: "Please select an image file",
        Channel_created_successfully: "Channel created successfully",
        Channel_updated_successfully: "Channel updated successfully",
        Channel_deleted_successfully: "Channel deleted successfully",
        Folder_not_found: "Folder not found",
        "Template_&_Project_data_has_been_added_successfully":
            "Template & Project data has been added successfully.",
        Project_data_has_been_added_successfully:
            "Project data has been added successfully{filterMessage}",
        Error_in_creating_project: "Error in creating project",
        Milestone_deleted_successfully: "Milestone deleted successfully",
        Error_in_deleting_milestone: "Error in deleting milestone",
        Milestone_added_successfully: "Milestone added successfully",
        Error_in_adding_milestone: "Error in adding milestone",
        Milestone_update_successfully: "Milestone update successfully",
        Error_in_updating_milestone: "Error in updating milestone",
        Milestone_status_update_successfully:
            "Milestone status update successfully",
        Error_in_updating_milestone_status:
            "Error in updating milestone status",
        Milestone_refund_amount_update_successfully:
            "Milestone refund amount update successfully",
        Error_in_updating_milestone_refund_amount:
            "Error in updating milestone refund amount",
        The_project_not_found: "The project not found.",
        The_project_is_archived: "The project is archived.",
        tracker_not_opened: "Hyphen OI Pro Tracker didn't open. Please make sure it's installed or updated to the latest version.",
        Start_date_of_project_should_be_smaller_than_current_date:
            "Start date of project should be smaller than current date",
        All_the_range_is_included_in_milestone:
            "All the range is included in milestone",
        Please_enter_start_date_of_project:
            "Please enter start date of project",
        Project_name_updated_successfully: "Project name updated successfully",
        "Project restored successfully": "Project restored successfully",
        "Project closed successfully": "Project closed successfully",
        "Project archived successfully": "Project archived successfully",
        "Project deleted successfully": "Project deleted successfully",
        Enter_valid_project_source: "Enter valid project source",
        Please_select_sub_task: "Please select sub task.",
        Status_not_updated: "Status not updated",
        Start_date_updated_successfully: "Start date updated successfully",
        Start_date_not_updated: "Start date not updated",
        Task_converted_sucessfully: "Task converted sucessfully",
        Task_merged_sucessfully: "Task merged sucessfully",
        Can_not_create_template_name_Custom:
            "Can not create template name Custom",
        Template_name_updated_successfully:
            "Template name updated successfully.",
        Template_has_been_created_Successfully:
            "Template has been created Successfully.",
        Template_deleted_successfull: "Template deleted successfully.",
        Template_has_been_deleted_successfully:
            "Template has been deleted successfully.",
        Storage_exceeded_Upgrade_your_plan:
            "Storage exceeded. Upgrade your plan",
        max_filesize_messages: "The max file size is FILE_SIZE MB.",
        Password_reset_email_has_been_sent_successfully:
            "Password reset email has been sent successfully",
        Invalid_username_or_password: "Invalid username or password.",
        Email_Not_Verified: "Email Not Verified.",
        Verification_mail_has_been_send_successfully:
            "Verification mail has been send successfully",
        Invalid_url: "Invalid url",
        User_already_registered: "User already registered.",
        User_has_been_registered_successfully:
            "User has been registered successfully.",
        The_email_address_is_already_in_use:
            "The email address is already in use",
        User_has_been_registered_successfully_Please_verify_your_email_to_continue:
            "User has been registered successfully, Please verify your email to continue.",
        Password_reset_has_been_successfully:
            "Password reset has been successfully",
        Your_email_has_been_verify_successfully:
            "Your email has been verify successfully",
        Invitation_accepted_successfully: "Invitation accepted successfully",
        Only_product_owner_can_create_a_company:
            "Only product owner can create a company",
        Company_name_must_be_unique: "Company name must be unique.",
        Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere:
            "Subscription cancel succesfully. Please allow 2 to 3 minutes for the changes to take effect everywhere.",
        Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere:
            "Subscription reactivate succesfully.  Please allow 2 to 3 minutes for the changes to take effect everywhere.",
        View_name_is_required: "View name is required",
        name_should_be_at_least_3_characters_long:
            "name should be at least 3 characters long",
        View_name_already_exists: "View name already exists",
        View_added_successfully: "View added successfully",
        View_Deleted_Successfully: "View Deleted Successfully",
        Link_copied_to_clipboard_successfully:
            "Link copied to clipboard successfully",
        Project_avatar_updated_successfully:
            "Project avatar updated successfully",
        "Message pinned successfully": "Message pinned successfully",
        "Message unpinned successfully": "Message unpinned successfully",
        Message_copied: "Message copied",
        Item_cannot_be_empty: "Item cannot be empty",
        Maximum_MAX_CHAR_characters_are_allowed:
            "Maximum MAX_CHAR characters are allowed",
        Item_added_to_checklist: "Item added to checklist",
        Maximum_10_files_can_be_uploaded_at_once:
            "Maximum 10 files can be uploaded at once",
        file_type_is_not_supported: "file type is not supported!",
        ERROR_in_file_upload: "ERROR in file upload",
        file_size_is_larger_than_FILE_SIZE_mb:
            "file size is larger than FILE_SIZE mb!",
        Mark_as_favorite_successfully: "Mark as favorite successfully",
        Start_and_Due_date_updated_successfully:
            "Start and Due date updated successfully",
        Start_and_Due_date_not_updated: "Start and Due date not updated",
        Attchments_deleted_successfully: "Attchments deleted successfully",
        Designation_is_required: "Designation is required",
        Designation_already_exists: "Designation already exists",
        Designation_added_successfully: "Designation added successfully",
        Designation_updated_successfully: "Designation updated successfully",
        Role_is_required: "Role is required",
        Role_already_exists: "Role already exists",
        Role_added_successfully: "Role added successfully",
        Role_updated_successfully: "Role updated successfully",
        Please_provide_an_email_id: "Please provide an email id",
        Please_provide_a_designation: "Please provide a designation",
        Please_provide_a_role: "Please provide a role",
        Designation_deleted_successfully: "Designation deleted successfully",
        "The_role_is_already_in_use_so_it_can't_be_deleted":
            "The role is already in use, so it can't be deleted.",
        Role_deleted_successfully: "Role deleted successfully",
        Language_not_updated: "Language not updated!",
        Profile_updated_successfully: "Profile updated successfully.",
        two_factor_enabled: "Two-factor authentication enabled.",
        two_factor_disabled: "Two-factor authentication disabled.",
        two_factor_invalid: "That code is not valid.",
        two_factor_codes_copied: "Recovery codes copied to clipboard.",
        webhook_created: "Webhook created.",
        webhook_updated: "Webhook updated.",
        webhook_deleted: "Webhook deleted.",
        Notification_Settings_Update_successfully:
            "Notification Settings Update successfully",
        Permission_updated_successfully: "Permission updated successfully",
        Per_User_Generate_Limit_value_is_not_valid:
            "Per User Generate Limit value is not valid",
        Team_name_is_required: "Team name is required",
        Minimum_3_character_required: "Minimum 3 character required",
        Team_name_already_exist: "Team name already exist",
        Template_has_been_added_successfully:
            "Template has been added successfully.",
        Billing_details_has_been_updated_successfully:
            "Billing details has been updated successfully",
        Billing_details_not_updated: "Billing details not updated",
        Invalid_Card_Details_Please_check_and_try_again:
            "Invalid Card Details.Please check and try again.",
        Expired_Card_Please_check_and_try_again:
            "Expired Card.Please check and try again.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again":
            "Invalid card verification code (CVC).Please check and try again.",
        You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again:
            "You have cancel your current subscription at term end please reactivate subscription and try again.",
        Plan_not_purchased_Please_try_again:
            "Plan not purchased. Please try again.",
        Please_fill_out_billing_details_first:
            "Please fill out billing details first.",
        Please_check_your_credential: "Please check your credentials.",
        File_type_not_supported: "file type is not supported",
        Are_you_sure_to_delete_this_file: "Are you sure to delete this file?",
        Select_Project_Type: "Select Project Type",
        Tracker_user_added_successfully: "Tracker user added successfully",
        Tracker_user_removed_successfully: "Tracker user removed successfully",
        queue_list_not_updated: "QueueList non mis à jour.",
        upgrade_plan_folder_limit_reached:
            "Upgrade your plan. You have reached the limit for creating folders",
        View_updated_successfully: "View updated successfully",
        The_designation_is_already_in_use_so_it_cant_be_deleted:
            "The designation is already in use, so it can't be deleted",
        Sprint_already_exists: "Sprint already exists",
        Folder_already_exists: "Folder already exists",
        "Sprint updated successfully": "Sprint updated successfully",
        Project_milestone_status_updated_successfully:
            "Project milestone status updated successfully.",
        Invalid_email: "Your email is invalid. Please check and try again",
        Invalid_password:
            "Your password is invalid. Please check and try again",
        Too_many_request: "Too many requests. Please try again later",
        Password_reset_link:
            "Password expiry email sent successfully! Please check your inbox to proceed with resetting your password.",
        Project_milestone_status_added_successfully:
            "Project milestone status added successfully.",
        Please_select_start_end_date: "Please select both start and end date",
        Invitation_canceled:
            "Invitation canceled: You can no longer use this link",
        Ai_limit_reached: "Your daily limit has been reached",
        You_have_reached_the_maximum_limit_of_guest_users:
            "Upgrade your Plan.You have reached the maximum limit of guest users",
        Upgrade_for_import: "Upgrade your plan to access Import functionality.",
        Upgrade_for_export: "Upgrade your plan to access Export functionality.",
        import_task_success: "Your Tasks have been Imported Successfully.",
        export_task_success: "Tasks exported successfully",
        export_task_error: "There are no tasks to export.",
        invalid_file_error: "Invalid file type. Please upload a .csv file.",
        free_company_limit_reached:
            "You've reached the maximum limit for creating free companies.",
        Import_users_successfully: "Users imported successfully",
        date_range: "Please select a date range before applying.",
        Task_total_estimate_update_succesfull:
            "Task toal estimate update successfully.",
    },
    SecurityAndPermission: {
        project: "Project",
        project_list: "Project List",
        project_create: "Project Create",
        project_name_edit: "Project Name Edit",
        project_sprint_create: "Project Sprint Create",
        project_folder_create: "Project folder Create",
        project_folder_name_edit: "Project folder Name Edit",
        project_sprint_name_edit: "Project sprint Name Edit",
        project_details: "Project Details",
        project_status_change: "Project Status Change",
        project_assignee: "Project Assignee",
        project_category: "Project Category",
        project_source: "Project Source",
        project_type: "Project Type",
        project_currency: "Project Currency",
        project_amount: "Project Amount",
        project_start_date: "Project Start Date",
        project_end_date: "Project End Date",
        project_due_date: "Project Due Date",
        project_close: "Project Close",
        project_description: "Project Description",
        project_checklist: "Project Checklist",
        project_checklist_assign_remove: "Project Checklist Assign/remove",
        project_attachments: "Project Attachments",
        project_milestone: "Project Milestone",
        task: "Task",
        task_list: "Task list",
        task_create: "Task Create",
        sub_task_create: "Sub Task Create",
        task_name_edit: "Task Name Edit",
        task_status: "Task Status",
        task_assignee: "Task Assignee",
        task_priority: "Task Priority",
        task_due_date: "Task Due Date",
        task_estimated_hours: "Task Estimated Hours",
        task_description: "Task Description",
        task_checklist: "Task Checklist",
        task_checklist_assign_remove: "Task Checklist Assign/remove",
        task_attachments: "Task Attachments",
        show_tasks: "Show Tasks",
        task_custom_field: "Custom Field",
        settings: "Company Settings",
        settings_edit_company: "Edit Company",
        settings_task_priority: "Task Priority",
        settings_file_extensions: "File Extensions",
        settings_project_milestone_status: "Project Milestone Status",
        settings_invite_member: "Invite Member",
        settings_member_list: "Member list",
        settings_create_team: "Create Team",
        settings_team_list: "Team List",
        settings_project_list: "Project List",
        settings_security_permissions: "Security & Permissions",
        settings_role_management: "Role Management",
        settings_designation: "Designation",
        milestone_weekly_range: "Milestone Weekly Range",
        settings_custom_field: "Custom Field",
        sheet_settings: "Sheet Settings",
        user_timesheet: "User Timesheet",
        project_timesheet: "Project Timesheet",
        workload_timesheet: "Workload Timesheet",
        milestone_report: "Milestone Report",
        artificial_intelligence: "Artificial Intelligence",
        per_user_generate_limit: "Per User Token Limit",
        project_custom_field: "Custom Field",
        public_projects: "Public Project List",
        private_projects: "Private Project List",
        tracker_timesheet: "Tracker Timesheet",
        view_list: "View List",
        project_delete: "Project Delete",
        chat: "Chat",
        folder_archive: "Folder Archive",
        folder_delete: "Folder Delete",
        folder_restore: "Folder Restore",
        sprint_archive: "Sprint Archive",
        sprint_delete: "Sprint Delete",
        sprint_restore: "Sprint Restore",
        sprint_type_change: "Sprint Type Change",
        one_to_one_chat: "One To One Chat",
        chat_category: "Chat Category Create",
        chat_channel: "Chat Channel Create",
        task_tag: "Task Tag",
        task_start_date: "Task Start Date",
        task_activity_log: "Task Activity Log",
        task_convert_to_list: "Task Convert to List",
        task_convert_to_subtask: "Task Convert to Subtask",
        task_duplicate: "Task Duplicate",
        task_merge: "Task Merge",
        task_move: "Task Move",
        task_archive: "Task Archive",
        task_delete: "Task Delete",
        task_comment: "Task Comment",
        task_details: "Task Details",
        queue_list: "Queue List",
        advance_search: "Advance Search",
        list_view_column: "List View Column",
        task_type: "Task Type",
        import_tasks: "Import Tasks",
        export_tasks: "Export Tasks",
        convert_to_task: "Convert to Task",
    },
    general: {
        Continue: "Continue",
        New_Status: "New Status",
        Old_Status: "Old Status",
        Old_Task_Type: "Old Task Type",
        New_Task_Type: "New Task Type",
        New_Task_Assignee: "New Task Assignee",
        Old_Task_Assignee: "Old Task Assignee",
        New_Task_Watchers: "New Task Watchers",
        Old_Task_Watchers: "Old Task Watchers",
        Select_Status: "Select Status",
        Select_Task_Type: "Select Task Type",
        No_Assignee: "No Assignee",
        No_Watchers: "No Watchers",
        Different_Statuses: "Different Statuses",
        Please_Select_Status: "Please Select Status",
        Tomorrow: "Tomorrow",
        Yesterday: "Yesterday",
        Project: "Project",
        Team: "Team",
        User: "User",
        Copy_Assignees: "Copy Assignees",
        Copy_Watchers: "Copy Watchers",
        apply: "Apply",
        current_month: "Current Month",
        current_week: "Current Week",
        keyboard: "Keyboard",
        mouse: "Mouse",
        Create: "Create",
        scroll_to_bottom: "Scroll to Bottom",
        unassigned: "Unassigned",
        entries: "entries",
        showing: "Showing",
        page_not_found: "Oops, page not found",
        page_not_found_description:
            "We are very sorry for the inconvenience. It looks like you’re trying to access a page that has been deleted or never even existed.",
        note: "Note",
        settings_change_no_effect:
            "The change of below settings won't affect current field values if not empty",
        advanced: "Advanced",
        general: "General",
        limits: "Limits",
        message_deleted: "Message Deleted",
        company_individual: "Company/Individual Name",
        enter_company_individual: "Enter Company/Individual Name",
    },
    monthName: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec",
    },
    timeLog: {
        start_time_field_required: "The start time field is required",
        end_time_field_required: "The end time field is required",
        select_valid_time_duration: "Please select valid time duration",
    },
    weekName: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        fridays: "Fridays",
        mondays: "Mondays",
        saturdays: "Saturdays",
        sundays: "Sundays",
        thursdays: "Thursdays",
        tuesdays: "Tuesdays",
        wednesdays: "Wednesdays",
    },
    tooltipText: {
        enable_app_manage_priority:
            "By enabling this app you will be able to manage <b>Priority</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_manage_multiple_assignee:
            "By enabling this app you will be able to manage <b>Multiple Assignee</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_manage_time_estimates:
            "By enabling this app you will be able to manage <b>Time Estimates</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_manage_tags:
            "By enabling this app you will be able to manage <b>Tags</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_use_milestones:
            "By enabling this app you will be able to use <b>Milestones</b> for this <b>project</b>",
        enable_app_use_ai_operations:
            "By enabling this app you will be able to use <b>AI operations</b> for this <b>project</b>",
        enable_app_manage_time_log:
            "By enabling this app you will be able to manage <b>Time log</b> in <b>Tasks</b> for this <b>project</b>",
        enable_app_manage_custom_fields:
            "By enabling this app you will be able to manage <b>Custom Fields</b> for this <b>project</b>",
    },
    Company: {
        fill_company_details: "Fill in your company details",
        set_up_company: "Set up your Company",
        creating_company: "Creating Company",
        company_created:
            "Your company was created. We have set up the initial steps. Please wait a moment.",
        good_to_go: "Good To Go",
        select_default_country: "Select the Default Country",
        freelimitreachedstart:
            "You have already created a free company, To create a new company, you need to upgrade",
        freelimitreachedend:
            "to a paid plan first. Once upgraded, you will be all set to add another free company.",
    },
    Subscription: {
        subscription_cancelled:
            "You have cancelled your subscription at the end of the current subscription period",
        discard_changes:
            "A user to your subscription will discard these changes, and your current subscription will continue from the next billing cycle.",
        confirm_terminate_schedule:
            "Are you sure you want to terminate the schedule subscription cancellation?",
        confirm_add_user:
            "Are you sure you want to add user in your subscription?",
        confirm_remove_user:
            "Are you sure you want to remove the user from the subscription?",
        next_invoice_amount: "Your next invoice will be of",
        credits_applied: "Credits Applied",
        current_billing_for_upgrade: "Current Billing for Upgrade",
        plan_upgrade_success:
            "Congratulations! Your plan upgrade has been scheduled successfully, and the enhancements will take effect after the current term ends. Get ready to experience the upgraded features and benefits in the next phase of your subscription.",
        subscription_upgrade_from: "Your Subscription Will Upgrade from",
        total_payable_amount: "Total Payable Amount",
        update_subscription: "Update Subscription",
        updated_subscription_price: "Updated Subscription Price",
        upgrade_subscription: "Upgrade Subscription",
        confirm_subscription_change:
            "Are you sure you want to change your subscription from",
        monthly: "Month",
        yearly: "Year",
        remove_scheduled_cancellation_confirmation:
            "Clicking 'Yes' will remove the scheduled cancellation and your billing cycle will continue.",
        scheduled_cancellation_notice:
            "You have a scheduled cancellation of your current subscription on",
        credit_entitlement_congratulations:
            "Congratulations! You're entitled to a credit of",
        credit_note_application:
            "for your current subscription. This credit note will be effortlessly applied to enhance your subscription, and it will also be automatically deducted from your upcoming invoices, guaranteeing ongoing value and savings for your subscription journey.",
        invoice_period_coverage: "The invoice covers the period from",
    },
    Card: {
        pay_with: "Pay with",
        add_new_card: "Add New Card",
        name_on_card: "Name on Card",
        card_number: "Card Number",
        expiry: "Expiry",
        cvc: "CVC",
    },
    alertBox: {
        updateBillingAddress: "You need to update the first billing address",
        valid_csv_title: "No File Uploaded",
        valid_csv_text: "Please upload a valid .csv file in order to proceed.",
        ok: "OK",
        cancel: "Cancel",
        go_back_title: "Go Back?",
        go_back_text: "Are you sure you want to return to the previous step?",
        close_modal_title: "Close Modal?",
        close_modal_text:
            "Are you sure you want to close the modal? All your data until this step will be lost.",
        no: "No",
        yes: "Yes",
        confirm: "Confirm",
        improper_header_selection_title: "Inappropriate Selection",
        improper_header_selection_text:
            "Selected row contains non-string values. Please select a different row.",
        missing_fields_title: "Missing Required Fields",
        missing_fields_text:
            "The following required fields must be mapped & confirmed before proceeding",
        warning_title: "Warning",
        warning_text:
            "When you proceed, any empty data values in 'Task Priority' & 'Status' will be treated as 'Medium' and 'To Do' respectively.",
        incomplete_mapping_title: "Incomplete Mapping",
        incomplete_mapping_text:
            "Kindly map all the unique values to at least one Hyphen OI Pro value in order to Proceed.",
        invalid_tasks_error:
            "No valid tasks found. Please ensure required fields are not empty.",
    },
    importTaskButton: {
        import_title: "Import Tasks",
        import_button: "Import Tasks From CSV",
        back_button: "Go Back",
        next_button: "Proceed",
        export_button: "Export as CSV",
        import_processing: "Your Tasks are bring Imported.",
    },
    importCsvAndSetHeader: {
        download: "Download",
        demo_csv: "Demo CSV",
        down_demo_text:
            "file and compare it to your import file to ensure you have the perfect file for import.",
        upload_button: "Upload your CSV File Here",
        upload_instructions:
            "You can upload any .csv file with any set of columns as long as it has 1 record per row. The next step will allow you to map your spreadsheet columns to the right data points. You'll be able to clean up or remove any corrupted data before finalizing your report.",
        header_row_question: "Does the selected row contain column headers?",
        select_another_button: "Select Another Row",
        confirm_row_btt: "Confirm",
    },
    headerMapping: {
        title: "Header Mapping",
        mapping_instructions: "Let's map your headers with Hyphen OI Pro Headers",
        pending_count: "Pending Fields:",
        confirmed_count: "Confirmed Fields:",
        ignored_count: "Ignored Fields:",
        custom_count: "Custom Fields:",
        confirmed_text: "Confirmed",
        ignored_text: "Ignored",
        edit_button: "Edit",
        no_match_title: "No Match",
        no_match: "No Match Found",
        no_match_description:
            "This field doesn't match with any of our headers. Kindly ignore this or include it as custom field.",
        custom_field_button: "Include as Custom Field",
        ignore_field_button: "Ignore this Field",
        matched_to_field: "Matched to the field:",
        duplication_warning:
            "This field is a duplicate and cannot be confirmed. Please choose a different field.",
        confirm_map_button: "Confirm Mapping",
    },
    reviewMaping: {
        title: "Kindly review your data mapped in our fields. (You can also edit the data values here.)",
        warning:
            "You have one or more required fields with missing or invalid values. Kindly review them or else those rows will not be imported.",
    },
    valueMapping: {
        user_mapping_title: "User Mapping",
        user_mapping_instruction:
            "Map users to Hyphen OI Pro users in order to preserve assignees, leaders, and task activity. If you don't map users, the data will NOT still be imported as it cannot be synced to Hyphen OI Pro users.",
        user_dropdown_text: "Select a user",
        status_mapping_title: "Status Mapping",
        status_mapping_instruction:
            "To ensure consistency in future workflows, please map your Status values to the existing values in Hyphen OI Pro. This will help avoid any discrepancies moving forward.",
        status_dropdown_text: "Select a Status",
        priority_mapping_title: "Priority Mapping",
        priority_mapping_instruction:
            "To ensure consistency in future workflows, please map your Priority values to the existing values in Hyphen OI Pro. This will help avoid any discrepancies moving forward.",
        priority_dropdown_text: "Select a Priority",
        custom_field_mapping_title: "Custom Field Mapping",
        custom_field_mapping_instruction:
            "To ensure consistency in future workflows, please map the type of your Custom Fields to the existing types in Hyphen OI Pro. This will help avoid any discrepancies moving forward.",
        custom_delimiters_quest:
            "ℹ️ Do you have any delimiters separating the values of this Custom Field?",
    },
    importMappingKeywords: {
        task_id_description: "The ID of the particular task.",
        task_name_description:
            "The name of the task, typically a brief summary.",
        task_description_description: "Detailed information about the task.",
        task_assignee_description:
            "The email address of the person assigned to the task.",
        task_parentId_description:
            "The ID of the parent task this task is associated with.",
        task_leaderId_description:
            "The user ID of the person leading this task.",
        task_priority_description:
            "The level of importance assigned to the task.",
        task_status_description: "The current state or progress of the task.",
        task_start_date_description: "The date when the task begins.",
        task_due_date_description:
            "The date by which the task should be completed.",
    },
    Affiliate: {
        refer_earn: "Refer & Earn",
        unlimited: "Unlimited",
        invite_start_earning_cash_rewards:
            "Invite your friends and start earning cash rewards.",
        your_referral_code: "Your Referral Code",
        invite_spend_message:
            "For your friend every spends, you’ll receive {percentage}% of that amount as a reward.",
        inviteText: "Invite Friends by sharing this link",
        copy: "Copy",
        refferal_code_label: "Refferal Code",
        refferal_code_placeholder: "Enter Referral Code",
        invalid_refferal_model_title: "Your refferal code is invalid",
        invalid_refferal_model_confirm_text: "Yes, Create it!",
        invalid_refferal_model_text: "Are you sure you want to create company?",
        refferal_code_error: "Refferal code is not valid",
    },
    dashboardCard: {
        project_scope_all: "All projects",
        project_scope_include: "Include",
        project_scope_exclude: "Exclude",
        tasks_by_status_card_title: "Tasks by Status",
        tasks_by_status_card_description: "Count of tasks grouped by status",
        tasks_by_project_card_title: "Tasks by Project",
        tasks_by_project_card_description: "Count of tasks grouped by project",
        total_tasks_card_title: "Total Tasks",
        total_tasks_card_description: "A single total count of tasks",
        active_projects_card_title: "Active Projects",
        active_projects_card_description: "Count of active projects (status is not closed)",
        task_status_summary_card_title: "Tasks Summary by Status",
        task_status_summary_card_description: "A counter per task status for the selected period, broken down per person. Click any count in the table to list that person's tasks in that status. Owner/Admin see the whole company; everyone else sees their own tasks",
        tss_no_status: "No task statuses are configured yet.",
        tss_no_tasks: "No tasks in this status for the selected period.",
        tss_loading_tasks: "Loading tasks…",
        tss_total: "{n} tasks in the selected period",
        tss_scope_company: "Company-wide",
        tss_scope_self: "My tasks",
        tss_unknown_status: "Unknown status",
        tss_capped: "Showing the first {n} tasks.",
        tss_col_user: "Username",
        tss_col_planned: "Planned Hours",
        tss_col_logged: "Logged Hours",
        tss_col_overdue: "Overdue Hours",
        tss_overdue_hint: "How far the period is on course to run past its plan. Finished tasks count what they actually logged; unfinished ones count their plan, or the time already spent if that is more. The result is netted across the row, so a task brought in early offsets one that overran.",
        tss_col_other: "Other",
        tss_other_hint: "Tasks with hours in this period that sit in a status this card is not showing. The hours columns count them, so this is where they are.",
        tss_open_other: "Show {user}'s tasks outside the selected statuses",
        tss_search_user_placeholder: "Search user…",
        tss_no_users: "Nobody has tasks in the selected period.",
        tss_no_user_match: "No user matches “{q}”.",
        tss_users_capped: "Showing the first {n} users.",
        tss_unassigned: "Unassigned",
        tss_open_cell: "Show {user}'s tasks in {status}",
        tss_close_list: "Close",
        members_task_status_card_title: "Members by Task Status",
        members_task_status_card_description: "Every member's total currently-assigned tasks, broken down by status. Owner/Admin see the whole company; everyone else sees only themselves",
        mts_total: "{n} tasks assigned right now",
        mts_col_member: "Member",
        mts_col_total: "Total",
        mts_search_member_placeholder: "Search member…",
        mts_no_members: "No members to show.",
        mts_no_member_match: "No member matches “{q}”.",
        milestone_report_card_title: "Milestone Report",
        milestone_report_card_description: "Company-wide billing-milestone receivables consolidated to USD, with a received/outstanding split by period (Owner/Admin only)",
        milestone_management_only: "Only available to Owner/Admin",
        milestones: "milestones",
        milestone_by_status: "By Status",
        recent_milestones: "Recent Milestones",
        view_full_report: "View full report",
        no_milestones: "No milestones found",
        milestone_receivable: "Receivable",
        milestone_received: "Received",
        milestone_outstanding: "Outstanding",
        milestone_all_time: "All-time total",
        milestone_rates_approx: "approx. rates",
        milestone_none_in_period: "No milestones due in this period",
        milestone_timeline: "Milestone Timeline",
        milestone_col_name: "Milestone",
        milestone_col_date: "Date",
        milestone_col_amount: "Amount",
        milestone_open_project: "Open project details",
        milestone_project_closed: "Closed",
        milestone_project_closed_hint: "This project is closed, so it can no longer be opened. The milestone still counts — closed is not the same as paid.",
        milestone_project_closed_toast: "This project is closed, so it can no longer be opened from here.",
        milestone_overdue: "Overdue",
        milestone_past: "Past",
        milestone_due_today: "Due today",
        milestone_upcoming: "Upcoming",
        projects_by_type_card_title: "Projects by Type",
        projects_by_type_card_description: "Active projects grouped by type",
        project_progress: "Project Progress",
        running_projects_card_title: "Running Projects",
        running_projects_card_description: "Active projects with logged time in the selected period",
        live_work_card_title: "Active Time Trackers",
        live_work_card_description: "Who has a time tracker running right now, on what, and their tracker note",
        no_live_work: "No one is tracking time right now",
        no_data_available: "No data available",
        users_by_category_card_title: "Work by Category",
        users_by_category_card_description: "Number of tasks per user, grouped into your work categories (Development, Marketing, UI/UX, QA)",
        users_by_category_hint: "Each number is the count of tasks a person worked on in the selected period, per category.",
        category_template: "Category template",
        category_template_hint: "Pick a category, then tick the task types that belong to it. Each type belongs to one category.",
        search_task_types: "Search task types…",
        no_task_types: "No task types found for this company.",
        tasks_by_assignee_bar_chart_description:
            "Display a bar graph of your total tasks by Assignee",
        tasks_by_assignee_bar_chart_title: "Tasks by Assignee",
        task_list_description:
            "Create a List view using tasks from any location",
        tasks_list_title: "Task List",
        tasks_by_assignee_stack_bar_chart_description:
            "Display a battery of your total tasks by Assignee",
        tasks_by_assignee_stack_bar_chart_title: "Tasks by Assignee",
        workload_by_status_stack_bar_chart_description:
            "Display a breakdown of your statuses across locations",
        workload_by_status_stack_bar_chart_title: "Workload by Status",
        tasks_by_assignee_pie_chart_description:
            "Display a pie chart of your total tasks by Assignee",
        tasks_by_assignee_pie_chart_title: "Tasks by Assignee",
        workload_by_status_pie_chart_description:
            "Display a pie chart of your statuses usage across locations",
        workload_by_status_pie_chart_title: "Workload by Status",
        workload_by_status_bar_chart_description:
            "Display a bar chart of your statuses usage across locations",
        workload_by_status_bar_chart_title: "Workload by Status",
        queue_list_title: "Queue List",
        queue_list_description:
            "View a list of your tasks along with their statuses.",
        card_name: "card name",
        location: "project",
        group_by: "group by",
        show_assignees: "show assignees",
        include_subtasks: "include subtasks",
        display_labels_as_percent: "display labels as percent",
        show_legend: "show legend",
        show_Data_Labels: "show data labels",
        select: "select",
        add_card: "add card",
        back: "back",
        error_assignees: "The show assignees field is required",
        error_location: "The location field is required",
        empty_layout_container:
            "Your Dashboard is empty. Click 'Add Card' to begin.",
        status: "Status",
        edit_card: "edit card",
        calendar_card_title: "Calendar",
        calendar_card_description: "This is calendar view for task",
        measure: "measure",
        calculation: "calculation",
        total_urgent_tasks: "Total Urgent Tasks",
        total_urgent_tasks_description:
            "Display the total amount of Urgent tasks by location",
        time_tracker: "Time Tracker",
        time_estimate: "Time Estimate",
        range: "Range",
        max: "Max",
        min: "Min",
        median: "Median",
        average: "Average",
        sum: "Sum",
        workload_estination_title: "Time Reporting",
        workload_estination_description:
            "See tasks that have time tracked and estimated.",
        workload_only_estination_title: "Time Estimated",
        workload_only_estination_description: "See time estimated.",
        time_only_estination_title: "Time Tracked",
        time_only_estination_description: "See time tracked.",
        today: "Today",
        yesterday: "Yesterday",
        this_week: "This Week",
        last_week: "Last Week",
        this_month: "This Month",
        last_month: "Last Month",
        this_year: "This Year",
        last_30_days: "Last 30 Days",
        task_label: "task label",
        task: "Task Count",
        both: "Show both",
        manual_time: "Show manual time only",
        track_time: "Show tracked time only",
        logtype: "Time logs",
        timerange: "Time period",
        priority: "Priority",
        due_date: "Due Date",
        none: "None",
        total_time_track_description: "Display the total time track",
        total_time_track_tasks: "Total Time Track",
        total_tasks_count_description: "Display the total task count",
        total_tasks_count: "Total Number of Tasks",
        assignees: "Task Assignees",
        feature: "Feature",
        workload: "Workload",
        time_tracking: "Time Reporting",
        task_card: "Tasks",
        resource_utilization: "Resource Utilization",
        member: "My Workspace",
        me_option: "Me",
        next_up_card_title: "Next Up",
        next_up_card_description: "Your open tasks, ordered by due date then priority — what to do next.",
        next_up_empty: "You're all caught up — no open tasks.",
        next_up_limit: "How many tasks",
        due_soon_card_title: "Due Soon",
        due_soon_card_description: "Your tasks due within the next few days, soonest first.",
        due_soon_days: "Days ahead",
        due_soon_empty: "Nothing due in this window.",
        my_time_card_title: "My Time",
        my_time_card_description: "Your planned vs logged hours for the period.",
        mt_planned: "Planned",
        mt_over_plan: "Over Plan",
        mt_empty: "No planned or logged time in this period.",
        my_achievements_card_title: "My Achievements",
        my_achievements_card_description: "Your completion scorecard — tasks completed, within-estimate rate, on-time rate, and current streak.",
        ach_completed: "Completed",
        ach_on_estimate: "On estimate",
        ach_on_time: "On time",
        ach_streak: "Streak",
        ach_empty: "No completed tasks in this period.",
        ach_tab_wins: "Achievements",
        ach_tab_overdue: "Overdue",
        ach_tab_needs: "Over Estimate",
        ach_tab_wins_empty: "No clean deliveries yet — on time and within estimate show here.",
        ach_tab_overdue_empty: "Nothing delivered late this period. 🎉",
        ach_tab_needs_empty: "Nothing on-time went over estimate. 👍",
        my_leave_card_title: "My Leave",
        my_leave_card_description: "Your leave requests and their current status.",
        my_leave_setup_hint: "Pick your company's leave project in this card's settings to see your requests.",
        my_leave_empty: "You have no leave requests.",
        project_pulse_card_title: "Project Pulse",
        project_pulse_card_description: "Active projects, projects worked in the period, and the In House / Fixed / Hourly mix.",
        active_projects: "Active Projects",
        working_projects: "Working Projects",
        project_type_mix: "Project Type Mix",
        live_work_table_card_title: "Live Work",
        live_work_table_card_description: "Who is working on what right now (live trackers).",
        free_resources_card_title: "Free Resources",
        free_resources_card_description: "Team members with little planned work or nothing logged today (excludes those on leave).",
        worked_tasks_table_card_title: "Worked Tasks",
        worked_tasks_table_card_description: "Per user and project, how many tasks were worked on and where each currently sits, for the selected date range.",
        no_one_working_now: "No one is currently working on a task.",
        no_free_resources: "Everyone is currently allocated.",
        frc_reason: "Reason",
        lwt_user: "User",
        lwt_task: "Task",
        lwt_logged_today: "Logged Today",
        lwt_task_logged: "This Task",
        wtt_total_worked: "Tasks",
        wtt_in_progress: "In Progress",
        wtt_in_review: "In Review",
        wtt_backlog: "Backlog",
        wtt_complete: "Complete",
        team_category_breakdown_card_title: "Team Effort Breakdown",
        team_category_breakdown_card_description: "Where team energy goes — logged time by team, split by task type, effort nature (new/backlog/rework), work category, or billable, drilling to the members.",
        dim_type: "By Type",
        dim_effort_nature: "Effort Nature",
        dim_work_category: "Work Category",
        dim_billable: "Billable",
        team_logged_vs_eta_card_title: "Team Logged vs ETA",
        team_logged_vs_eta_card_description: "Per team, time logged versus the estimated time of the tasks worked.",
        tle_eta: "ETA",
        tle_logged: "Logged",
        tle_pct_hint: "% = Logged ÷ ETA · red = over estimate",
        free_threshold_hours: "Planned threshold (hours)",
        logged_threshold_hours: "Logged threshold (hours)",
        add_filter: "Add filter",
        on_leave_card_title: "On Leave",
        on_leave_card_description: "Approved leave tickets from your HR project for the selected period, with absent (AB) and present (PR) headcounts.",
        on_leave_setup_hint: "Pick the project that holds your leave tickets (and the approved status) in the card settings.",
        on_leave_absent: "Absent (AB)",
        on_leave_present: "Present (PR)",
        on_leave_tickets: "Leave Tickets",
        on_leave_ticket: "Ticket",
        on_leave_period: "Period",
        on_leave_no_one: "No one is on leave in this period.",
        auto_range: "Auto (dashboard range)",
        dashboard_range: "Date range",
        dashboard_range_hint: "Cards set to “Auto” follow this range",
        enable_date_range: "Enable date range filter",
        tasklist_date_range: "Date range",
        plm_type: "Type",
        plm_worked_in_period: "Worked in period",
        plm_yes: "Yes",
        plm_no: "No",
        plm_click_hint: "Click to see the projects behind this number",
        dashboard_settings: "Dashboard options",
        export_dashboard: "Export dashboard",
        import_dashboard: "Import dashboard",
        export_empty: "Your dashboard has no cards to export.",
        import_invalid: "That file isn't a valid Hyphen OI Pro dashboard export.",
        import_confirm_title: "Import dashboard",
        import_confirm_body: "This file has {n} cards. Merge adds them below your current {m}; Replace swaps your dashboard for them (can't be undone).",
        import_merge: "Merge (append)",
        import_replace: "Replace",
        import_success: "Dashboard imported successfully.",
        import_success_dropped: "Dashboard imported ({n} unsupported cards skipped).",
        import_merge_success: "{n} cards added to your dashboard.",
        employee_workload_report_title: "Employee Workload & Activity Report",
        employee_workload_report_description: "See who is working on what, with workload distribution, overdue flags, and learning vs actual breakdown.",
        active_within_minutes: "Active within (minutes)",
        idle_after_minutes: "Idle after (minutes)",
        overload_capacity_per_day: "Overload capacity / day (minutes)",
        tasks_per_employee_limit: "Tasks per employee",
        refresh_interval_seconds: "Refresh interval (seconds)",
        show_ai_summary: "Show AI summary",
        show_workload_chart: "Show workload chart",
        show_task_type_chart: "Show task-type chart",
        show_logged_hours: "Show Logged Hours",
        show_planned_hours: "Show Planned Hours",
        show_estimate_hours: "Show Estimate Hours",
        recently_added_projects: "Recently Added Projects",
        recently_added_projects_hint: "New projects from the last 2 days — tick one to add it to this card.",
        new_badge: "New",
        dismiss_recent_project: "Remove from suggestions",
        Today: "Today",
        Yesterday: "Yesterday",
        Tomorrow: "Tomorrow",
        overdue_days: "{n}d overdue",
        This_week: "This week",
        Next_week: "Next week",
        Next_seven_days: "Next 7 days",
        Last_seven_days: "Last 7 days",
        Last_month: "Last month",
        This_month: "This month",
        Next_month: "Next month",
        Date_range: "Date range",
        me_mode: "me",
        data: "Data",
        display: "Display",
        fields: "Fields",
    },
    designationMapping: {
        title: "Designation Mapping",
        description:
            "Kindly Map the Designations in your CSV to the existing Designations in Hyphen OI Pro.",
    },
    roleMapping: {
        title: "Role Mapping",
        description:
            "Kindly Map the Roles in your CSV to the existing Roles in Hyphen OI Pro.",
    },
    importUserKeywords: {
        user_email_description: "Email ID of the user",
        user_role_description:
            "The role or job title assigned to the user within the organization.",
        user_designation_description:
            "The official designation or job title of the employee within the company.",
    },
    userSelection: {
        title: "User Selection",
        user_limit_error:
            "Maximum user limit reached. Please upgrade your plan to import more users.",
        description: "Select all the users that you want to import.",
        duplicate_email_error:
            "This Email ID already exists in Hyphen OI Pro. You cannot import it.",
        invalid_email: "This Email ID is invalid. Kindly use a valid Email ID.",
        invalid_fields:
            "You have one of more Invalid fields. Kindly check the highlighted fields.",
        user_limit_100: "You can import a maximum of 100 users at once.",
    },
    importUserButton: {
        import_user_processing: "Your users are being Imported",
    },
    timeForecastingReport: {
        project_name: "Project Name",
        project_status: "Project Status",
        start_date: "Start Date",
        due_date: "Due Date",
        last_logged_date: "Last Logged Date",
        budget: "Budget",
        actual: "Actual",
        forecast: "Forecast",
        estimated_hours: "Estimated Hours",
        logged_hours: "Logged Hours",
        remaining_hours: "Remaining Hours",
        overdue_hours: "Overdue Hours",
        estimated_time_to_complete: "Estimated Time to Completion",
        estimated_complition_date: "Estimated Completion Date",
        show_legends: "Show Legends",
        show_data_labels: "Show Data Labels",
        report_type: "Report Type",
    },
    Changelog: {
        whats_new: "What's New",
        subtitle: "Every release and update, straight from the changelog.",
        view_whats_new: "See what's new in this version",
        current_version: "You're on",
        latest: "Latest",
        installed: "Installed",
        compare_changes: "Compare changes",
        view_on_github: "View on GitHub",
        no_releases: "No release notes available yet.",
        load_failed: "Couldn't load the changelog.",
        retry: "Retry",
    },
    Reminders: {
        title: "Reminder",
        header_tooltip: "Reminders",
        close: "Close",
        name_placeholder: "Reminder name",
        add_description: "Add description",
        description_placeholder: "Add more detail…",
        set_date: "Set date",
        today: "Today",
        tomorrow: "Tomorrow",
        next_week: "Next week",
        done: "Done",
        for_me: "For me",
        me_initial: "M",
        notify_me: "Notify me",
        on_due_date: "On due date",
        ten_minutes_before: "10 minutes before",
        one_hour_before: "1 hour before",
        custom: "Custom…",
        minutes_before: "minutes before",
        apply: "Apply",
        dont_notify: "Don't notify",
        attach: "Attach files",
        attachments: "Attachments",
        drag_files: "Drag and drop files to attach or",
        browse: "browse",
        remove: "Remove",
        create: "Create Reminder",
        creating: "Creating…",
        created: "Reminder created",
        failed: "Could not create the reminder. Try again.",
        invalid_date: "Pick a valid date and time.",
        panel_title: "Reminders",
        add: "Add reminder",
        loading: "Loading your reminders…",
        empty: "No reminders yet. Click \"Add reminder\" to create one.",
        filter_upcoming: "Upcoming",
        filter_done: "Completed",
        filter_all: "All",
        filter_assigned: "Assigned by me",
        for_user: "For {name}",
        another_user: "another user",
        pending: "Pending",
        mark_done: "Mark as done",
        mark_undone: "Mark as not done",
        options: "Options",
        delete: "Delete",
        deleted: "Reminder deleted",
        delete_failed: "Could not delete the reminder.",
        update_failed: "Could not update the reminder.",
        sent: "Sent",
        uploading: "Uploading files…",
        upload_failed: "Some files could not be uploaded.",
        edit: "Edit",
        edit_title: "Edit reminder",
        save: "Save changes",
        updated: "Reminder updated",
        snooze: "Snooze",
        snooze_10m: "10 minutes",
        snooze_1h: "1 hour",
        snooze_1d: "Tomorrow",
        snoozed: "Reminder snoozed",
        file_open_failed: "Could not open the file.",
    },
    Notepad: {
        title: "Notepad",
        hint: "Quick personal notes. Convert any note into a task.",
        add: "New note",
        loading: "Loading your notes…",
        empty: "No notes yet. Create one to get started.",
        placeholder: "Write a quick note…",
        editor_placeholder: "Write your note…",
        title_placeholder: "Untitled note",
        untitled: "Untitled note",
        no_content: "No content",
        back: "Back to notes",
        search: "Search notes",
        search_placeholder: "Search notes…",
        no_results: "No notes match your search.",
        show_archived: "Show archived",
        show_active: "Show active notes",
        empty_archived: "No archived notes.",
        sort_recent: "Sort by Recent",
        edit: "Open note",
        archive: "Archive",
        restore: "Restore",
        archived_toast: "Note archived",
        restored_toast: "Note restored",
        saving: "Saving…",
        saved: "All changes saved",
        confirm_delete_title: "Are you sure you want to delete this note?",
        confirm_delete_desc: "This action cannot be undone.",
        options: "Options",
        delete: "Delete note",
        convert_action: "Convert to task",
        converted_badge: "Converted",
        convert_title: "Convert note to task",
        task_name: "Task name",
        select_project: "Project",
        select_project_placeholder: "Select a project",
        select_sprint: "Sprint",
        select_sprint_placeholder: "Select a sprint",
        loading_sprints: "Loading sprints…",
        cancel: "Cancel",
        converting: "Converting…",
        name_length_error: "Task name must be between 3 and 250 characters.",
        select_project_required: "Please select a project.",
        select_sprint_required: "Please select a sprint.",
        project_not_ready: "This project has no default status or task type configured.",
    },
    Demo: {
        banner: "You're on the Hyphen OI Pro live demo — data may reset periodically.",
        login_with: "Log in with",
        star: "Star on GitHub",
        deploy: "Deploy your own",
    },
};
